<template>
    <!-- Container para toda la página: ******************************************************* -->
    <v-container fill-height fluid class="questionnaires">
        <!-- Layout para toda la página: *********************************************************** -->
        <v-layout align-center justify-center>
            <!-- Flex para la ventana: **************************************************************** -->
            <v-flex xs12 elevation-6>
                <div class="sub-window">
                    <v-toolbar dense dark color="teal darken-3">
                        <v-toolbar-title>Casos&nbsp;&nbsp;</v-toolbar-title>
                        <v-text-field hide-details single-line v-model="searchText"></v-text-field>
                        <v-btn small icon @click="onSearch">
                            <v-icon>mdi-magnify</v-icon>
                        </v-btn>
                        <v-spacer></v-spacer>
                        <v-toolbar-items class="hidden-sm-and-down">
                            <v-btn
                                :disabled="bEdit"
                                text
                                class="text-none"
                                @click="onNewQuestionnaire"
                            >Nuevo Caso</v-btn>
                            <v-btn
                                :disabled="bEdit || questionnaireID === 0"
                                text
                                class="text-none"
                                @click="onEditQuestionnaire"
                            >Editar Caso</v-btn>
                            <v-btn
                                :disabled="bEdit || questionnaireID === 0"
                                text
                                class="text-none"
                                @click="onDeleteQuestionnaire"
                            >Borrar Caso</v-btn>

                            <v-tooltip bottom>
                                <template v-slot:activator="{ on }">
                                    <v-btn text @click="onClose" v-on="on">
                                        <v-icon>mdi-close</v-icon>
                                    </v-btn>
                                </template>
                                <span>Cerrar</span>
                            </v-tooltip>
                        </v-toolbar-items>

                        <!-- Menú lateral para dispositivos con ventanas chicas: -->
                        <v-menu offset-y>
                            <template v-slot:activator="{ on }">
                                <v-btn icon v-on="on" class="hidden-md-and-up">
                                    <v-icon>mdi-dots-vertical</v-icon>
                                </v-btn>
                            </template>
                            <v-list color="grey lighten-4">
                                <v-list-item @click="onNewQuestionnaire">
                                    <v-list-item-title>
                                        <v-icon
                                            color="teal darken-1"
                                            :disabled="bEdit"
                                            @click="onNewQuestionnaire"
                                        >mdi-file-plus</v-icon>&nbsp; Nuevo Caso
                                    </v-list-item-title>
                                </v-list-item>
                                <v-list-item
                                    :disabled="bEdit"
                                    @click="onEditQuestionnaire"
                                >
                                    <v-list-item-title>
                                        <v-icon
                                            color="teal darken-1"
                                            :disabled="bEdit || questionnaireID === 0"
                                            @click="onEditQuestionnaire"
                                            >mdi-pencil</v-icon
                                        >&nbsp; Editar Caso
                                    </v-list-item-title>
                                </v-list-item>
                                <v-list-item @click="onDeleteQuestionnaire">
                                    <v-list-item-title>
                                        <v-icon
                                            color="teal darken-1"
                                            :disabled="bEdit || questionnaireID === 0"
                                            @click="onDeleteQuestionnaire"
                                        >mdi-delete</v-icon>&nbsp; Borrar Caso
                                    </v-list-item-title>
                                </v-list-item>
                                <v-divider></v-divider>
                                <v-list-item @click="onClose">
                                    <v-list-item-title>
                                        <v-icon color="red" @click="onClose">mdi-close</v-icon>&nbsp; Cerrar
                                    </v-list-item-title>
                                </v-list-item>
                            </v-list>
                        </v-menu>
                    </v-toolbar>

                    <!-- Container para lista de casos y caso seleccionado: -->
                    <v-container pa-2 grid-list-md fluid>
                        <!-- Renglón único para lista de casos y card de caso seleccionado: -->
                        <v-layout row wrap justify-space-around>
                            <!-- Lista de casos: *************************** -->
                            <v-flex xs10 sm4 md3>
                                <v-card>
                                    <v-toolbar dense color="teal darken-1" dark flat>
                                        <v-toolbar-title
                                            class="my-list-title"
                                        >Casos Registrados</v-toolbar-title>
                                        <v-spacer></v-spacer>
                                        <v-icon>mdi-format-list-bulleted</v-icon>
                                    </v-toolbar>

                                    <v-list
                                        subheader
                                        dense
                                        :height="listHeight"
                                        max-height="100%"
                                        class="overflow-y-auto"
                                        color="grey lighten-4"
                                        :disabled="bEdit || loadingQuestionnaire"
                                    >
                                        <v-list-item-group
                                            v-model="selectedQuestionnaireIndex"
                                            color="orange accent-4"
                                            :mandatory="!bNew"
                                        >
                                            <v-list-item
                                                class="my-list-item"
                                                v-for="(questionnaire, i) in questionnaires"
                                                :key="i"
                                                @click="selectQuestionnaire(questionnaire.id)"
                                            >
                                                <v-list-item-content>
                                                    <v-list-item-title>
                                                        <v-container pa-0 fluid>
                                                            <v-layout row wrap>
                                                                <v-flex
                                                                    md2
                                                                    xs6
                                                                >{{questionnaire.numero}}.{{ questionnaire.titulo }}</v-flex>
                                                            </v-layout>
                                                        </v-container>
                                                    </v-list-item-title>
                                                </v-list-item-content>
                                            </v-list-item>
                                        </v-list-item-group>
                                    </v-list>
                                </v-card>
                            </v-flex>

                            <!-- Termina lista de casos ********************************* -->

                            <!-- Info de caso seleccionado: *********************** -->
                            <v-flex xs10 sm8 md9>
                                <v-card class="grey lighten-4">
                                    <v-toolbar dense color="teal lighten-3" flat>
                                        <v-toolbar-title
                                            class="my-list-title"
                                        >{{ questionnaireNameTitle }}</v-toolbar-title>
                                        <v-spacer></v-spacer>
                                        <v-icon>mdi-clipboard-list-outline</v-icon>
                                    </v-toolbar>

                                    <v-card-text>
                                        <v-container fluid grid-list-xl>
                                            <v-layout>
                                                <v-flex xs12>
                                                    <v-card>
                                                        <v-card-title class="display-1 teal--text text--darken-3">
                                                            Caso {{ selectedQuestionnaireNumber }}
                                                        </v-card-title>
                                                        <v-card-text>
                                                            <v-container fluid grid-list-xl>
                                                                <v-layout row>
                                                                    <v-flex xs12 sm10>
                                                                        <v-text-field
                                                                            dense
                                                                            name="name"
                                                                            label="Nombre del caso"
                                                                            type="text"
                                                                            v-model="selectedQuestionnaireName"
                                                                            :readonly="!bEdit"
                                                                            color="teal darken-3"
                                                                        ></v-text-field>
                                                                    </v-flex>
                                                                    <v-flex xs2>
                                                                        <v-text-field
                                                                            dense
                                                                            name="num"
                                                                            label="Número del caso"
                                                                            type="number"
                                                                            v-model="selectedQuestionnaireNumber"
                                                                            :readonly="!bEdit"
                                                                            color="teal darken-3"
                                                                            reverse
                                                                        ></v-text-field>
                                                                    </v-flex>
                                                                </v-layout>
                                                                <v-layout row >
                                                                    <v-flex md12>
                                                                        <div class="text-xs-left">
                                                                            <span
                                                                                class="teal--text text--darken-3 caption"
                                                                            >
                                                                                <v-icon
                                                                                    color="teal darken-1"
                                                                                    >mdi-earth</v-icon
                                                                                >&nbsp;Idiomas:
                                                                            </span>
                                                                        </div>
                                                                    </v-flex>
                                                                </v-layout>

                                                                <v-layout row wrap>
                                                                    <v-flex
                                                                        xs4
                                                                        md3
                                                                        v-for="lang in questionnaireLangTable"
                                                                    >
                                                                        <v-checkbox
                                                                            :dense="bDense"
                                                                            :readonly="!bEdit"
                                                                            :key="lang.languageID"
                                                                            :label="lang.langName"
                                                                            v-model="lang.selected"
                                                                            color="orange accent-4"
                                                                            @change="onSelectLanguage(lang.languageID, lang.selected)"
                                                                        ></v-checkbox>
                                                                    </v-flex>
                                                                </v-layout>
                                                            </v-container>
                                                        </v-card-text>

                                                        <v-card-title
                                                            class="teal--text text--darken-3"
                                                        >
                                                            Introducción
                                                            <v-spacer></v-spacer>
                                                            <v-tooltip bottom>
                                                                <template v-slot:activator="{ on }">
                                                                    <v-btn
                                                                        :disabled="!bEdit"
                                                                        icon
                                                                        @click="onEditIntro"
                                                                        v-on="on"
                                                                    >
                                                                        <v-icon
                                                                            color="orange accent-4"
                                                                        >mdi-pencil</v-icon>
                                                                    </v-btn>
                                                                </template>
                                                                <span>Editar la introducción</span>
                                                            </v-tooltip>
                                                        </v-card-title>
                                                        <v-card-text>
                                                            <v-data-table
                                                                fixed-header
                                                                :headers="questionnaireTablesHeader"
                                                                :items="questionnaireIntroTable"
                                                                item-key="id"
                                                                locale="es-MX"
                                                                hide-default-footer
                                                                no-data-text="No se ha agregado una introducción para este caso."
                                                                :show-select="false"
                                                                single-select
                                                                dense
                                                                class="elevation-1"
                                                            ></v-data-table>
                                                        </v-card-text>
                                                    </v-card>
                                                </v-flex>
                                            </v-layout>

                                            <!-- Se despliegan las situaciones y las respuestas de cada situación: -->
                                            <v-layout row wrap>
                                                <!-- Lista de Situaciones: *************************** -->
                                                <v-flex
                                                    xs12
                                                    v-for="(situation, i) in questionnaireSituations"
                                                    :key="i"
                                                >
                                                    <v-card>
                                                        <v-card-title
                                                            class="teal--text text--darken-3"
                                                        >
                                                            Situación {{ situation.numero }}
                                                            <v-spacer></v-spacer>
                                                            <v-tooltip bottom>
                                                                <template v-slot:activator="{ on }">
                                                                    <v-btn
                                                                        :disabled="!bEdit"
                                                                        icon
                                                                        @click="editSituation(situation.situacionid, situation.numero)"
                                                                        v-on="on"
                                                                    >
                                                                        <v-icon
                                                                            color="orange accent-4"
                                                                        >mdi-pencil</v-icon>
                                                                    </v-btn>
                                                                </template>
                                                                <span>Editar la situación</span>
                                                            </v-tooltip>
                                                            <v-tooltip bottom>
                                                                <template v-slot:activator="{ on }">
                                                                    <v-btn
                                                                        :disabled="!bEdit"
                                                                        icon
                                                                        @click="onDeleteSituation(situation.situacionid, situation.numero)"
                                                                        v-on="on"
                                                                    >
                                                                        <v-icon
                                                                            color="orange accent-4"
                                                                        >mdi-delete-forever</v-icon>
                                                                    </v-btn>
                                                                </template>
                                                                <span>Borrar la situación</span>
                                                            </v-tooltip>
                                                        </v-card-title>
                                                        <v-card-text>
                                                            <v-container grid-list-md fluid>
                                                                <v-layout row>
                                                                    <v-radio-group
                                                                        dense
                                                                        v-model="situation.tipoSituacion"
                                                                        row
                                                                    >
                                                                        <v-radio
                                                                            :readonly = "!bEdit"
                                                                            label="Normal"
                                                                            color="orange accent-4"
                                                                            value="1"
                                                                        ></v-radio>
                                                                        <v-radio
                                                                            :readonly = "!bEdit"
                                                                            label="Priorizada"
                                                                            color="orange accent-4"
                                                                            value="2"
                                                                        ></v-radio>
                                                                    </v-radio-group>
                                                                </v-layout>
                                                                <v-layout row>
                                                                    <v-data-table
                                                                        fixed-header
                                                                        :headers="questionnaireTablesHeader"
                                                                        :items="questionnaireSituationTable[i]"
                                                                        item-key="id"
                                                                        locale="es-MX"
                                                                        hide-default-footer
                                                                        no-data-text="No hay texto para esta situación."
                                                                        :show-select="false"
                                                                        single-select
                                                                        dense
                                                                        class="elevation-1"
                                                                    ></v-data-table>
                                                                </v-layout>
                                                            </v-container>
                                                        </v-card-text>

                                                        <!-- <v-divider inset></v-divider> -->

                                                        <v-card-title
                                                            class="teal--text text--darken-3 body-2 font-weight-bold"
                                                        >
                                                            Respuestas
                                                            <v-spacer></v-spacer>
                                                            <v-tooltip bottom>
                                                                <template v-slot:activator="{ on }">
                                                                    <v-btn
                                                                        :disabled="!bEdit"
                                                                        icon
                                                                        @click="onNewAnswer(situation.situacionid)"
                                                                        v-on="on"
                                                                    >
                                                                        <v-icon
                                                                            color="orange accent-4"
                                                                        >mdi-comment-plus</v-icon>
                                                                    </v-btn>
                                                                </template>
                                                                <span>Agregar una respuesta</span>
                                                            </v-tooltip>
                                                        </v-card-title>
                                                        <v-card-text>
                                                            <v-data-table
                                                                fixed-header
                                                                :headers="questionnaireAnswerHeader"
                                                                :items="questionnaireAnswerTable[i]"
                                                                locale="es-MX"
                                                                hide-default-footer
                                                                no-data-text="No hay respuestas para esta situación."
                                                                :show-select="false"
                                                                :items-per-page="questionnaireAnswerTable[i].length"
                                                                class="elevation-1"
                                                            >
                                                                <template
                                                                    v-slot:item.control-edit="props"
                                                                >
                                                                    <v-tooltip bottom>
                                                                        <template
                                                                            v-slot:activator="{ on }"
                                                                        >
                                                                            <v-btn
                                                                                icon
                                                                                @click="onEditAnswer(i + 1, props.item, situation.tipoSituacion)"
                                                                                v-on="on"
                                                                            >
                                                                                <v-icon
                                                                                    color="orange accent-4"
                                                                                >mdi-comment-edit</v-icon>
                                                                            </v-btn>
                                                                        </template>
                                                                        <span>Configuración de la respuesta</span>
                                                                    </v-tooltip>
                                                                </template>
                                                                <template
                                                                    v-slot:item.control-delete="props"
                                                                >
                                                                    <v-tooltip bottom>
                                                                        <template
                                                                            v-slot:activator="{ on }"
                                                                        >
                                                                            <v-btn
                                                                                icon
                                                                                @click="onDeleteAnswer(situation.situacionid, props.item)"
                                                                                v-on="on"
                                                                                :disabled="!bEdit"
                                                                            >
                                                                                <v-icon
                                                                                    color="orange accent-4"
                                                                                >mdi-delete-forever</v-icon>
                                                                            </v-btn>
                                                                        </template>
                                                                        <span>Borrar esta respuesta</span>
                                                                    </v-tooltip>
                                                                </template>
                                                            </v-data-table>
                                                        </v-card-text>

                                                        <v-card-title
                                                             class="teal--text text--darken-3 body-2 font-weight-bold"
                                                        >
                                                            Autoevaluación
                                                            <v-spacer></v-spacer>
                                                            <v-tooltip bottom v-if="Object.keys(questionnaireAutoevaluationTable[i][0]).length > 1">
                                                                <template v-slot:activator="{ on }">
                                                                    <v-btn
                                                                        icon
                                                                        @click="onEditAutoevaluation(situation.situacionid, i + 1)"
                                                                        v-on="on"
                                                                    >
                                                                        <v-icon
                                                                            color="orange accent-4"
                                                                        >mdi-pencil</v-icon>
                                                                    </v-btn>
                                                                </template>
                                                                <span>Configuración de la autoevaluación</span>
                                                            </v-tooltip>
                                                            <v-tooltip bottom v-else>
                                                                <template v-slot:activator="{ on }">
                                                                    <v-btn
                                                                        :disabled="!bEdit"
                                                                        icon
                                                                        @click="onNewAutoevaluation(situation.situacionid)"
                                                                        v-on="on"
                                                                    >
                                                                        <v-icon
                                                                            color="orange accent-4"
                                                                        >mdi-eye-plus-outline</v-icon>
                                                                    </v-btn>
                                                                </template>
                                                                <span>Agregar autoevaluación</span>
                                                            </v-tooltip>
                                                            <v-tooltip bottom v-if="Object.keys(questionnaireAutoevaluationTable[i][0]).length > 1">
                                                                <template v-slot:activator="{ on }">
                                                                    <v-btn
                                                                        :disabled="!bEdit"
                                                                        icon
                                                                        @click="onDeleteAutoevaluation(situation.situacionid)"
                                                                        v-on="on"
                                                                    >
                                                                        <v-icon
                                                                            color="orange accent-4"
                                                                        >mdi-eye-remove-outline</v-icon>
                                                                    </v-btn>
                                                                </template>
                                                                <span>Borrar la autoevaluación</span>
                                                            </v-tooltip>
                                                        </v-card-title>

                                                        <v-card-title
                                                            class="teal--text text--darken-3 body-2 pt-0 pb-0"
                                                            v-if="Object.keys(questionnaireAutoevaluationTable[i][0]).length > 1"
                                                        >
                                                            Un ejecutivo contestó lo siguiente:
                                                            
                                                        </v-card-title>

                                                        <v-card-text v-if="Object.keys(questionnaireAutoevaluationTable[i][0]).length > 1">
                                                            <v-data-table
                                                                fixed-header
                                                                :headers="questionnaireTablesHeader"
                                                                :items="questionnaireAutoevaluationTable[i]"
                                                                locale="es-MX"
                                                                hide-default-footer
                                                                no-data-text="No hay autoevaluación para esta situación."
                                                                :show-select="false"
                                                                single-select
                                                                dense
                                                            >
                                                            </v-data-table>
                                                        </v-card-text>
                                                    </v-card>
                                                </v-flex>
                                                <!-- Termina Lista de Situaciones ********************************* -->
                                            </v-layout>

                                            <v-layout v-if="(bNew || bEdit)" align-center justify-end row fill-height>
                                                <v-flex
                                                    xs12
                                                    sm8
                                                    class="text-xs-center text-end"
                                                >
                                                    <v-btn
                                                        color="teal darken-3"
                                                        class="text-none"
                                                        text
                                                        @click="onNewSituation"
                                                        >
                                                        <v-icon>mdi-clipboard-plus</v-icon>&nbsp;Agregar Situación
                                                        </v-btn>
                                                </v-flex>
                                            </v-layout>
                                       

                                            <v-layout
                                                v-if="(bNew || bEdit)"
                                                align-center
                                                justify-end
                                                row
                                                fill-height
                                            >
                                                <v-flex
                                                    xs12
                                                    sm8
                                                    class="text-xs-center text-end"
                                                >
                                                    <v-btn
                                                        color="teal darken-3"
                                                        class="text-none"
                                                        text
                                                        @click="onSave"
                                                        >OK</v-btn
                                                    >
                                                    <v-btn
                                                        color="pink darken-1"
                                                        class="text-none"
                                                        text
                                                        @click="onCancel"
                                                        >Cancelar</v-btn
                                                    >
                                                </v-flex>
                                            </v-layout>
                                        </v-container>
                                    </v-card-text>
                                </v-card>
                            </v-flex>
                            <!-- Termina info de Cuestionario seleccionado *********************** -->
                        </v-layout>

                        <!-- Modal para confirmar borrado de caso: **************************************** -->
                        <v-layout row justify-center>
                            <v-dialog v-model="bDeletingQuestionnaire" persistent max-width="35%">
                                <v-card class="grey lighten-4">
                                    <v-toolbar dense color="orange darken-2" dark flat>
                                        <v-toolbar-title class="my-list-title">Borrar Cuestionario</v-toolbar-title>
                                        <v-spacer></v-spacer>
                                        <v-icon>mdi-delete</v-icon>
                                    </v-toolbar>
                                    <v-card-title class="text-center">
                                        <div style="margin: auto">
                                            <v-icon large color="orange darken-2">mdi-alert</v-icon>
                                        </div>
                                        &nbsp; ¿Desea borrar el caso {{ selectedQuestionnaireName }}?
                                    </v-card-title>
                                    <v-card-text
                                        class="text-center"
                                    >Esta acción no se puede deshacer.</v-card-text>
                                    <v-card-actions>
                                        <v-spacer></v-spacer>
                                        <v-btn
                                            color="teal darken-3"
                                            class="text-none"
                                            text
                                            @click="deleteQuestionnaireConfirmed"
                                        >OK</v-btn>
                                        <v-btn
                                            color="pink darken-1"
                                            class="text-none"
                                            text
                                            @click="cancelDeleteQuestionnaire"
                                        >Cancelar</v-btn>
                                    </v-card-actions>
                                </v-card>
                            </v-dialog>
                        </v-layout>
                        <!-- Termina Modal para confirmar borrado de caso *************************** -->

                        <!-- Modal para editar la introducción del caso: **************************************** -->
                        <v-layout row justify-center>
                            <v-dialog
                                v-model="bDlgEditIntro"
                                persistent
                                :width="editModalWidth"
                            >
                                <v-card class="grey lighten-4">
                                    <v-toolbar dense color="teal lighten-3" flat>
                                        <v-toolbar-title
                                            class="my-list-title"
                                        >Introducción</v-toolbar-title>
                                        <v-spacer></v-spacer>
                                        <v-icon>mdi-pencil</v-icon>
                                    </v-toolbar>
                                    
                                    <v-card-text>
                                        <v-container fluid grid-list-md>
                                            <v-layout
                                                v-for="(qintro, i) in questionnaireIntroArray"
                                                :key="i"
                                            >
                                                <v-flex xs12>
                                                    <v-textarea
                                                        dense
                                                        prepend-icon="mdi-earth"
                                                        :label="qintro.languageName"
                                                        type="text"
                                                        v-model="qintro.intro"
                                                        color="teal darken-3"
                                                        no-resize
                                                        rows="5"
                                                    ></v-textarea>
                                                </v-flex>
                                            </v-layout>
                                        </v-container>
                                    </v-card-text>

                                    <v-card-actions>
                                        <v-spacer></v-spacer>
                                        <v-btn
                                            color="teal darken-3"
                                            class="text-none"
                                            text
                                            @click="onConfirmIntroEdition"
                                        >OK</v-btn>
                                        <v-btn
                                            color="pink darken-1"
                                            class="text-none"
                                            text
                                            @click="onCancelIntroEdition"
                                        >Cancelar</v-btn>
                                    </v-card-actions>
                                </v-card>
                            </v-dialog>
                        </v-layout>
                        <!-- Termina Modal para editar la introducción *************************** -->

                        <!-- Modal para confirmar deselección de un idioma: **************************************** -->
                        <v-layout row justify-center>
                            <v-dialog v-model="bDlgDeletingLanguage" persistent max-width="35%">
                                <v-card class="grey lighten-4">
                                    <v-toolbar dense color="orange darken-2" dark flat>
                                        <v-toolbar-title class="my-list-title">Borrar idioma del caso</v-toolbar-title>
                                        <v-spacer></v-spacer>
                                        <v-icon>mdi-delete</v-icon>
                                    </v-toolbar>
                                    <v-card-title class="text-center">
                                        <div style="margin: auto">
                                            <v-icon large color="orange darken-2">mdi-alert</v-icon>
                                        </div>
                                        &nbsp; Si desmarca este idioma para este caso todos los textos en este idioma serán borrados. ¿Desea continuar?
                                    </v-card-title>
                                    
                                    <v-card-actions>
                                        <v-spacer></v-spacer>
                                        <v-btn
                                            color="teal darken-3"
                                            class="text-none"
                                            text
                                            @click="onConfirmUnselectLanguage(true)"
                                        >Sí</v-btn>
                                        <v-btn
                                            color="pink darken-1"
                                            class="text-none"
                                            text
                                            @click="onConfirmUnselectLanguage(false)"
                                        >No</v-btn>
                                    </v-card-actions>
                                </v-card>
                            </v-dialog>
                        </v-layout>
                        <!-- Termina Modal para confirmar deselección de un idioma *************************** -->

                        <!-- Modal para editar el nombre de una situación: **************************************** -->
                        <v-layout row justify-center>
                            <v-dialog v-model="bDlgEditSituationName" persistent :width="editModalWidth">
                                <v-card class="grey lighten-4">
                                    <v-toolbar dense color="teal lighten-3" flat>
                                        <v-toolbar-title
                                            class="my-list-title"
                                        >Situación {{ editingSituationNumber }}</v-toolbar-title>
                                        <v-spacer></v-spacer>
                                        <v-icon>mdi-pencil</v-icon>
                                    </v-toolbar>
                                    <v-card-text>
                                        <v-container fluid grid-list-md>
                                            <v-layout v-for="(name, i) in situationNameArray" :key="i">
                                                <v-flex xs12>
                                                    <v-textarea
                                                        dense
                                                        prepend-icon="mdi-earth"
                                                        :label="name.languageName"
                                                        type="text"
                                                        v-model="name.name"
                                                        color="teal darken-3"
                                                        no-resize
                                                        rows="5"
                                                    ></v-textarea>
                                                </v-flex>
                                            </v-layout>
                                        </v-container>
                                    </v-card-text>

                                    <v-card-actions>
                                        <v-spacer></v-spacer>
                                        <v-btn
                                            color="teal darken-3"
                                            class="text-none"
                                            text
                                            @click="onConfirmSituationEdition"
                                        >OK</v-btn>
                                        <v-btn
                                            color="pink darken-1"
                                            class="text-none"
                                            text
                                            @click="onCancelSituationEdition"
                                        >Cancelar</v-btn>
                                    </v-card-actions>
                                </v-card>
                            </v-dialog>
                        </v-layout>
                        <!-- Termina Modal para editar el nombre de una situación *************************** -->

                        <!-- Modal para editar una respuesta normal: **************************************** -->
                        <v-layout row justify-center>
                            <v-dialog v-model="bDlgEditAnswer" persistent :width="editAnswerModalWidth">
                                <v-card class="grey lighten-4">
                                    <v-toolbar dense color="teal lighten-3" flat>
                                        <v-toolbar-title
                                            class="my-list-title"
                                        >Respuesta {{ editingAnswerNumber }} - Situación {{ editingSituationNumber }}</v-toolbar-title>
                                        <v-spacer></v-spacer>
                                        <v-icon>mdi-comment-edit</v-icon>
                                    </v-toolbar>
                                    <v-card-text>
                                        <v-container fluid grid-list-md>
                                            <v-layout
                                                align-center
                                                row
                                                v-for="(answer, i) in answerLangArray"
                                                :key="i"
                                            >
                                                <v-flex xs2 sm1 class="teal--text text-lighten-2 caption">
                                                    <v-icon color="teal darken-3">
                                                        mdi-earth
                                                    </v-icon>
                                                   
                                                        {{ answer.languageName }}
                                                   
                                                </v-flex>
                                                <v-flex xs10 sm3>
                                                    <v-textarea
                                                        dense
                                                        :readonly = "!bEdit"
                                                        label="Respuesta"
                                                        type="text"
                                                        v-model="answer.summary"
                                                        color="teal darken-3"
                                                        no-resize
                                                        rows="1"
                                                        auto-grow
                                                    ></v-textarea>
                                                </v-flex>
                                                <v-flex xs12 sm8>
                                                    <v-textarea
                                                        dense
                                                        :readonly = "!bEdit"
                                                        label="Detalles"
                                                        type="text"
                                                        v-model="answer.details"
                                                        color="teal darken-3"
                                                        no-resize
                                                        rows="1"
                                                        auto-grow
                                                    ></v-textarea>
                                                </v-flex>
                                            </v-layout>
                                            
                                            <v-card-title class="teal--text text--darken-3 body-1 font-weight-bold">Evaluación</v-card-title>
                                            <v-layout row wrap justify-space-between>
                                                <v-flex xs4>
                                                    <v-card shaped class="grey lighten-4">
                                                        <v-card-title class="teal--text text--darken-3 body-2 font-weight-bold">Inteligencia critico-conceptual</v-card-title>
                                                        <v-card-text>
                                                            <v-container fluid grid-list-md>
                                                                <v-layout row wrap justify-space-between>
                                                                    <v-flex xs12>
                                                                        <v-text-field
                                                                            :readonly = "!bEdit"
                                                                            prepend-icon="mdi-head-cog-outline"
                                                                            label="Análisis"
                                                                            name="analisis"
                                                                            type="number"
                                                                            color="teal darken-3"
                                                                            v-model="respAnalisis"
                                                                        ></v-text-field>
                                                                        
                                                                    </v-flex>
                                                                </v-layout>
                                                                <v-layout row wrap justify-space-between>
                                                                     <v-flex xs12>
                                                                        <v-text-field
                                                                            :readonly = "!bEdit"
                                                                            prepend-icon="mdi-scale-balance"
                                                                            name="costobeneficio"
                                                                            label="Costo/Beneficio"
                                                                            type="number"
                                                                            color="teal darken-3"
                                                                            v-model="respCostoBeneficio"
                                                                        ></v-text-field>
                                                                    </v-flex>
                                                                </v-layout>
                                                                <v-layout row wrap justify-space-between>
                                                                    <v-flex xs12>
                                                                        <v-text-field
                                                                            :readonly = "!bEdit"
                                                                            prepend-icon="mdi-calendar-clock"
                                                                            name="largoplazo"
                                                                            label="Largo plazo"
                                                                            type="number"
                                                                            color="teal darken-3"
                                                                            v-model="respLargoPlazo"
                                                                        ></v-text-field>
                                                                    </v-flex>
                                                                </v-layout>
                                                                <v-layout row wrap justify-space-between>
                                                                    <v-flex xs12>
                                                                        <v-text-field
                                                                            :readonly = "!bEdit"
                                                                            prepend-icon="mdi-thought-bubble-outline"
                                                                            name="conceptual"
                                                                            label="Pensamiento conceptual"
                                                                            type="number"
                                                                            color="teal darken-3"
                                                                            v-model="respPensamientoConceptual"
                                                                        ></v-text-field>
                                                                    </v-flex>
                                                                </v-layout>
                                                            </v-container>
                                                        </v-card-text>
                                                    </v-card>
                                                </v-flex>
                                                <v-flex xs4>
                                                    <v-card shaped class="grey lighten-4">
                                                        <v-card-title class="teal--text text--darken-3 body-2 font-weight-bold">Inteligencia de relacionamiento</v-card-title>
                                                        <v-card-text>
                                                            <v-container fluid grid-list-md>
                                                                <v-layout row wrap justify-space-between>
                                                                    <v-flex xs12>
                                                                        <v-text-field
                                                                            :readonly = "!bEdit"
                                                                            prepend-icon="mdi-account-switch"
                                                                            name="interpersonal"
                                                                            label="Interpersonal"
                                                                            type="number"
                                                                            color="teal darken-3"
                                                                            v-model="respInterpersonal"
                                                                        ></v-text-field>
                                                                    </v-flex>
                                                                </v-layout>
                                                                <v-layout row wrap justify-space-between>
                                                                    <v-flex xs12>               
                                                                        <v-text-field
                                                                            :readonly = "!bEdit"
                                                                            prepend-icon="mdi-account-network"
                                                                            name="estrategico"
                                                                            label="Relacionamiento estratégico"
                                                                            type="number"
                                                                            color="teal darken-3"
                                                                            v-model="respRelacionamiento"
                                                                        ></v-text-field>
                                                                    </v-flex>
                                                                </v-layout>
                                                                <v-layout row wrap justify-space-between>
                                                                    <v-flex xs12>
                                                                        <v-text-field
                                                                            :readonly = "!bEdit"
                                                                            prepend-icon="mdi-account-group"
                                                                            name="social"
                                                                            label="Social"
                                                                            type="number"
                                                                            color="teal darken-3"
                                                                            v-model="respSocial"
                                                                        ></v-text-field>
                                                                    </v-flex>
                                                                </v-layout>
                                                            </v-container>
                                                        </v-card-text>
                                                    </v-card>
                                                </v-flex>
                                                <v-flex xs4>
                                                    <v-card shaped class="grey lighten-4">
                                                        <v-card-title class="teal--text text--darken-3 body-2 font-weight-bold">Conocimiento y aprendizaje</v-card-title>
                                                        <v-card-text>
                                                            <v-container fluid grid-list-md>
                                                                <v-layout row wrap justify-space-between>
                                                                    <v-flex xs12>
                                                                        <v-text-field
                                                                            :readonly = "!bEdit"
                                                                            class="centered-input"
                                                                            prepend-icon="mdi-eye-check"
                                                                            name="autoconocimiento"
                                                                            label="Autoconocimiento"
                                                                            type="number"
                                                                            color="teal darken-3"
                                                                            v-model="respAutoconocimiento"
                                                                        ></v-text-field>
                                                                    </v-flex>
                                                                </v-layout>
                                                                <v-layout row wrap justify-space-between>
                                                                    <v-flex xs12>
                                                                        <v-text-field
                                                                            :readonly = "!bEdit"
                                                                            prepend-icon="mdi-account-convert"
                                                                            name="ajuste"
                                                                            label="Capacidad de ajuste"
                                                                            type="number"
                                                                            color="teal darken-3"
                                                                            v-model="respAjuste"
                                                                        ></v-text-field>
                                                                    </v-flex>
                                                                </v-layout>
                                                                <v-layout row wrap justify-space-between>
                                                                    <v-flex xs12>
                                                                        <v-text-field
                                                                            :readonly = "!bEdit"
                                                                            prepend-icon="mdi-head-check-outline"
                                                                            name="etica"
                                                                            label="Pensamiento ético"
                                                                            type="number"
                                                                            color="teal darken-3"
                                                                            v-model="respEtica"
                                                                        ></v-text-field>
                                                                    </v-flex>
                                                                </v-layout>
                                                            </v-container>
                                                        </v-card-text>
                                                    </v-card>
                                                </v-flex>
                                            </v-layout>
                                            <v-layout>
                                                <v-flex xs12 class="text-xs-center text-end">
                                                    <v-btn
                                                        color="teal darken-3"
                                                        class="text-none"
                                                        text
                                                        @click="onConfirmAnswerEdition"
                                                    >OK</v-btn>
                                                    <v-btn
                                                        :disabled = "!bEdit"
                                                        color="pink darken-1"
                                                        class="text-none"
                                                        text
                                                        @click="onCancelAnswerEdition"
                                                    >Cancelar</v-btn>
                                                </v-flex>
                                            </v-layout>
                                        </v-container>
                                    </v-card-text>
                                </v-card>
                            </v-dialog>
                        </v-layout>
                        <!-- Termina Modal para editar una respuesta normal *************************** -->

                        <!-- Modal para editar una respuesta priorizada: **************************************** -->
                        <v-layout row justify-center>
                            <v-dialog v-model="bDlgEditPrioritizedAnswer" persistent :width="editPrioritizedAnswerWidth">
                                <v-card class="grey lighten-4">
                                    <v-toolbar dense color="teal lighten-3" flat>
                                        <v-toolbar-title
                                            class="my-list-title"
                                        >Respuesta {{ editingAnswerNumber }} - Situación {{ editingSituationNumber }}</v-toolbar-title>
                                        <v-spacer></v-spacer>
                                        <v-icon>mdi-comment-edit</v-icon>
                                    </v-toolbar>
                                    <v-card-text>
                                        <v-container fluid grid-list-md>
                                            <v-layout
                                                align-center
                                                row
                                                v-for="(answer, i) in answerLangArray"
                                                :key="i"
                                            >
                                                <v-flex xs2 class="teal--text text-lighten-2 caption">
                                                    <v-icon color="teal darken-3">
                                                        mdi-earth
                                                    </v-icon>
                                                   
                                                        {{ answer.languageName }}
                                                   
                                                </v-flex>
                                                <v-flex xs10 sm12>
                                                    <v-textarea
                                                        dense
                                                        :readonly = "!bEdit"
                                                        label="Respuesta"
                                                        type="text"
                                                        v-model="answer.summary"
                                                        color="teal darken-3"
                                                        no-resize
                                                        rows="1"
                                                        auto-grow
                                                    ></v-textarea>
                                                </v-flex>
                                            </v-layout>
                                            
                                            <v-card-title class="teal--text text--darken-3 body-1 font-weight-bold">Evaluación</v-card-title>
                                            <v-layout row wrap justify-space-around>
                                                <v-flex xs4>
                                                    <v-card shaped class="grey lighten-4">
                                                        <v-card-title class="teal--text text--darken-3 body-2 font-weight-bold">Relacionamiento estratégico</v-card-title>
                                                        <v-card-text>
                                                            <v-container fluid grid-list-md>
                                                                <v-layout row wrap justify-space-between>
                                                                    <v-flex xs12>
                                                                        <v-text-field
                                                                            :readonly = "!bEdit"
                                                                            prepend-icon="mdi-numeric-1-circle"
                                                                            label="1 o 2"
                                                                            type="number"
                                                                            color="teal darken-3"
                                                                            v-model="relEstrategico1"
                                                                        ></v-text-field>
                                                                    </v-flex>
                                                                </v-layout>
                                                                <v-layout row wrap justify-space-between>
                                                                     <v-flex xs12>
                                                                        <v-text-field
                                                                            :readonly = "!bEdit"
                                                                            prepend-icon="mdi-numeric-3-circle"
                                                                            label="3 o 4"
                                                                            type="number"
                                                                            color="teal darken-3"
                                                                            v-model="relEstrategico3"
                                                                        ></v-text-field>
                                                                    </v-flex>
                                                                </v-layout>
                                                                <v-layout row wrap justify-space-between>
                                                                    <v-flex xs12>
                                                                        <v-text-field
                                                                            :readonly = "!bEdit"
                                                                            prepend-icon="mdi-numeric-5-circle"
                                                                            label="5"
                                                                            type="number"
                                                                            color="teal darken-3"
                                                                            v-model="relEstrategico5"
                                                                        ></v-text-field>
                                                                    </v-flex>
                                                                </v-layout>
                                                                <v-layout row wrap justify-space-between>
                                                                    <v-flex xs12>
                                                                        <v-text-field
                                                                            :readonly = "!bEdit"
                                                                            prepend-icon="mdi-delete-alert"
                                                                            label="Eliminó"
                                                                            type="number"
                                                                            color="teal darken-3"
                                                                            v-model="relEstrategico0"
                                                                        ></v-text-field>
                                                                    </v-flex>
                                                                </v-layout>
                                                            </v-container>
                                                        </v-card-text>
                                                    </v-card>
                                                </v-flex>
                                                <v-flex xs4>
                                                    <v-card shaped class="grey lighten-4">
                                                        <v-card-title class="teal--text text--darken-3 body-2 font-weight-bold">Relacionamiento social</v-card-title>
                                                        <v-card-text>
                                                            <v-container fluid grid-list-md>
                                                                <v-layout row wrap justify-space-between>
                                                                    <v-flex xs12>
                                                                        <v-text-field
                                                                            :readonly = "!bEdit"
                                                                            prepend-icon="mdi-numeric-1-circle"
                                                                            label="1 o 2"
                                                                            type="number"
                                                                            color="teal darken-3"
                                                                            v-model="relSocial1"
                                                                        ></v-text-field>
                                                                    </v-flex>
                                                                </v-layout>
                                                                <v-layout row wrap justify-space-between>
                                                                     <v-flex xs12>
                                                                        <v-text-field
                                                                            :readonly = "!bEdit"
                                                                            prepend-icon="mdi-numeric-3-circle"
                                                                            label="3 o 4"
                                                                            type="number"
                                                                            color="teal darken-3"
                                                                            v-model="relSocial3"
                                                                        ></v-text-field>
                                                                    </v-flex>
                                                                </v-layout>
                                                                <v-layout row wrap justify-space-between>
                                                                    <v-flex xs12>
                                                                        <v-text-field
                                                                            :readonly = "!bEdit"
                                                                            prepend-icon="mdi-numeric-5-circle"
                                                                            label="5"
                                                                            type="number"
                                                                            color="teal darken-3"
                                                                            v-model="relSocial5"
                                                                        ></v-text-field>
                                                                    </v-flex>
                                                                </v-layout>
                                                                <v-layout row wrap justify-space-between>
                                                                    <v-flex xs12>
                                                                        <v-text-field
                                                                            :readonly = "!bEdit"
                                                                            prepend-icon="mdi-delete-alert"
                                                                            label="Eliminó"
                                                                            type="number"
                                                                            color="teal darken-3"
                                                                            v-model="relSocial0"
                                                                        ></v-text-field>
                                                                    </v-flex>
                                                                </v-layout>
                                                            </v-container>
                                                        </v-card-text>
                                                    </v-card>
                                                </v-flex>
                                            </v-layout>
                                            <v-layout>
                                                <v-flex xs12 class="text-xs-center text-end">
                                                    <v-btn
                                                        color="teal darken-3"
                                                        class="text-none"
                                                        text
                                                        @click="onConfirmAnswerEdition"
                                                    >OK</v-btn>
                                                    <v-btn
                                                        :disabled = "!bEdit"
                                                        color="pink darken-1"
                                                        class="text-none"
                                                        text
                                                        @click="onCancelAnswerEdition"
                                                    >Cancelar</v-btn>
                                                </v-flex>
                                            </v-layout>
                                        </v-container>
                                    </v-card-text>
                                </v-card>
                            </v-dialog>
                        </v-layout>
                        <!-- Termina Modal para editar una respuesta priorizada*************************** -->

                        <!-- Modal para editar la autoevaluación de una situación: **************************************** -->
                        <v-layout row justify-center>
                            <v-dialog v-model="bDlgEditAutoevaluation" persistent :width="autoEvalModalWidth">
                                <v-card class="grey lighten-4">
                                    <v-toolbar dense color="teal lighten-3" flat>
                                        <v-toolbar-title
                                            class="my-list-title"
                                        >Autoevaluación de la Situación {{ editingSituationNumber }}</v-toolbar-title>
                                        <v-spacer></v-spacer>
                                        <v-icon>mdi-pencil</v-icon>
                                    </v-toolbar>
                                    <v-card-text>
                                        <v-container fluid grid-list-md>
                                            <v-layout v-for="(autoevaltxt, i) in autoevaluationTextArray" :key="i">
                                                <v-flex xs12>
                                                    <v-textarea
                                                        dense
                                                        :readonly = "!bEdit"
                                                        prepend-icon="mdi-earth"
                                                        :label="autoevaltxt.languageName"
                                                        type="text"
                                                        v-model="autoevaltxt.autoeval"
                                                        color="teal darken-3"
                                                        no-resize
                                                        rows="6"
                                                    ></v-textarea>
                                                </v-flex>
                                            </v-layout>
                                            <v-layout align-center justify-left row>
                                                <v-flex xs12>
                                                    <v-radio-group
                                                        dense
                                                        v-model="autoEvalType"
                                                        row
                                                    >
                                                        <v-radio
                                                            :readonly = "!bEdit"
                                                            label="Evaluación de la respuesta alterna   "
                                                            color="orange accent-4"
                                                            value="0"
                                                        ></v-radio>
                                                        <v-radio
                                                            :readonly = "!bEdit"
                                                            label="Evaluación con información complementaria"
                                                            color="orange accent-4"
                                                            value="1"
                                                        ></v-radio>
                                                    </v-radio-group>
                                                </v-flex>
                                                
                                            </v-layout>
                                            <v-layout v-if="autoEvalType==='0'" align-center justify-center row>
                                                <v-flex xs10>
                                                    <v-data-table
                                                        :readonly = "!bEdit"
                                                        :headers="autoEvalHeader"
                                                        :items="autoEvalTableValues"
                                                        hide-default-footer
                                                        class="elevation-1"
                                                    >
                                                        <template v-if="bEdit" v-slot:item.mejor="props">
                                                            <v-edit-dialog
                                                                :return-value="props.item.mejor"
                                                                @save="saveAutoEvalItem(0, props.item, props.item.mejor)"
                                                                @cancel="cancelAutoEvalItem"
                                                                @open="openAutoEvalItem"
                                                                @close="closeAutoEvalItem"
                                                                large
                                                                persistent
                                                                cancel-text="Cancelar"
                                                                save-text="OK"
                                                                class="text-none"
                                                            >
                                                                {{ props.item.mejor }}
                                                                <template v-slot:input>
                                                                    <div class="teal--text text--darken-3 body-2 font-weight-bold">
                                                                        Mejor
                                                                    </div>
                                                                    <v-text-field
                                                                        dense
                                                                        v-model="props.item.mejor"
                                                                        label="Editar"
                                                                        single-line
                                                                        color="teal darken-3"
                                                                    ></v-text-field>
                                                                </template>
                                                            </v-edit-dialog>
                                                        </template>
                                                        <template v-if="bEdit" v-slot:item.similar="props">
                                                            <v-edit-dialog
                                                                :return-value="props.item.similar"
                                                                @save="saveAutoEvalItem(1, props.item, props.item.similar)"
                                                                @cancel="cancelAutoEvalItem"
                                                                @open="openAutoEvalItem"
                                                                @close="closeAutoEvalItem"
                                                                large
                                                                persistent
                                                                cancel-text="Cancelar"
                                                                save-text="OK"
                                                                class="text-none"
                                                            >
                                                                <div>{{ props.item.similar }}</div>
                                                                <template v-slot:input>
                                                                    <div class="teal--text text--darken-3 body-2 font-weight-bold">
                                                                        Similar
                                                                    </div>
                                                                    <v-text-field
                                                                        dense
                                                                        v-model="props.item.similar"
                                                                        label="Editar"
                                                                        single-line
                                                                        color="teal darken-3"
                                                                    ></v-text-field>
                                                                </template>
                                                            </v-edit-dialog>
                                                        </template>
                                                        <template v-if="bEdit" v-slot:item.menos1="props">
                                                            <v-edit-dialog
                                                                :return-value="props.item.menos1"
                                                                @save="saveAutoEvalItem(2, props.item, props.item.menos1)"
                                                                @cancel="cancelAutoEvalItem"
                                                                @open="openAutoEvalItem"
                                                                @close="closeAutoEvalItem"
                                                                number
                                                                large
                                                                persistent
                                                                cancel-text="Cancelar"
                                                                save-text="OK"
                                                                class="text-none"
                                                            >
                                                                {{ props.item.menos1 }}
                                                                <template v-slot:input>
                                                                    <div class="teal--text text--darken-3 body-2 font-weight-bold">
                                                                        Menos 1
                                                                    </div>
                                                                    <v-text-field
                                                                        dense
                                                                        v-model="props.item.menos1"
                                                                        label="Editar"
                                                                        single-line
                                                                        color="teal darken-3"
                                                                    ></v-text-field>
                                                                </template>
                                                            </v-edit-dialog>
                                                        </template>
                                                        <template v-if="bEdit" v-slot:item.menos2="props">
                                                            <v-edit-dialog
                                                                :return-value="props.item.menos2"
                                                                @save="saveAutoEvalItem(3, props.item, props.item.menos2)"
                                                                @cancel="cancelAutoEvalItem"
                                                                @open="openAutoEvalItem"
                                                                @close="closeAutoEvalItem"
                                                                large
                                                                persistent
                                                                cancel-text="Cancelar"
                                                                save-text="OK"
                                                                class="text-none"
                                                            >
                                                                {{ props.item.menos2 }}
                                                                <template v-slot:input>
                                                                    <div class="teal--text text--darken-3 body-2 font-weight-bold">
                                                                        Menos 2
                                                                    </div>
                                                                    <v-text-field
                                                                        dense
                                                                        v-model="props.item.menos2"
                                                                        label="Editar"
                                                                        single-line
                                                                        color="teal darken-3"
                                                                    ></v-text-field>
                                                                </template>
                                                            </v-edit-dialog>
                                                        </template>
                                                    </v-data-table>
                                                </v-flex>
                                            </v-layout>
                                            <v-layout v-else align-center justify-center row>
                                                <v-flex xs6>
                                                    <v-card width="100%">
                                                        <v-container  grid-list-md>
                                                            <v-layout row justify-center>
                                                                <v-flex xs8 md6>
                                                                    <v-text-field
                                                                        prepend-icon="mdi-thumb-up-outline"
                                                                        name="mantengo"
                                                                        label="Mantengo, estaba bien"
                                                                        type="number"
                                                                        :readonly="!bEdit"
                                                                        color="teal darken-3"
                                                                        v-model="mantengoBien"
                                                                    ></v-text-field>
                                                                </v-flex>
                                                            </v-layout>
                                                            <v-layout row justify-center>
                                                                <v-flex xs8 md6>
                                                                    <v-text-field
                                                                        prepend-icon="mdi-thumb-down-outline"
                                                                        name="mantengo_mal"
                                                                        label="Mantengo, estaba mal"
                                                                        type="number"
                                                                        :readonly="!bEdit"
                                                                        color="teal darken-3"
                                                                        v-model="mantengoMal"
                                                                    ></v-text-field>
                                                                </v-flex>
                                                            </v-layout>
                                                            <v-layout row justify-center>
                                                                <v-flex xs8 md6>
                                                                    <v-text-field
                                                                        prepend-icon="mdi-hand-okay"
                                                                        name="cambio_bien"
                                                                        label="Cambio, estaba bien"
                                                                        type="number"
                                                                        :readonly="!bEdit"
                                                                        color="teal darken-3"
                                                                        v-model="cambioBien"
                                                                    ></v-text-field>
                                                                </v-flex>
                                                            </v-layout>
                                                            <v-layout row justify-center>
                                                                <v-flex xs8 md6>
                                                                    <v-text-field
                                                                        prepend-icon="mdi-hand-right"
                                                                        name="cambio_mal"
                                                                        label="Cambio, estaba mal"
                                                                        type="number"
                                                                        :readonly="!bEdit"
                                                                        color="teal darken-3"
                                                                        v-model="cambioMal"
                                                                    ></v-text-field>
                                                                </v-flex>
                                                            </v-layout>
                                                        </v-container>
                                                    </v-card>
                                                </v-flex>
                                            </v-layout>
                                        </v-container>
                                    </v-card-text>

                                    <v-card-actions>
                                        <v-spacer></v-spacer>
                                        <v-btn
                                            color="teal darken-3"
                                            class="text-none"
                                            text
                                            :disabled="bDisableExitAutoEval"
                                            @click="onConfirmAutoevaluationEdition"
                                        >OK</v-btn>
                                        <v-btn
                                            :disabled = "!bEdit || bDisableExitAutoEval"
                                            color="pink darken-1"
                                            class="text-none"
                                            text
                                            @click="onCancelAutoevaluationEdition"
                                        >Cancelar</v-btn>
                                    </v-card-actions>
                                </v-card>
                            </v-dialog>
                        </v-layout>
                        <!-- Termina Modal para editar la autoevaluación de una situación *************************** -->

                        <!-- Modal para informar que no hubo resultados en la búsqueda: *********************************** -->
                        <v-layout row justify-center>
                            <v-dialog v-model="bShowNotFoundAlert" persistent max-width="30%">
                                <v-card class="grey lighten-4">
                                    <v-toolbar dense color="teal" dark flat>
                                        <v-toolbar-title
                                            class="my-list-title"
                                        >Búsqueda de Casos</v-toolbar-title>
                                        <v-spacer></v-spacer>
                                        <v-icon>mdi-magnify</v-icon>
                                    </v-toolbar>
                                    <v-card-text>
                                        <v-container>
                                            <v-layout row>
                                                <v-flex xs12 class="d-flex justify-center">
                                                    <v-icon large color="orange darken-2">mdi-warning</v-icon>
                                                </v-flex>
                                            </v-layout>
                                            <v-layout row>
                                                <v-flex
                                                    xs12
                                                    class="d-flex justify-center"
                                                >No hay casos registrados con ese nombre.</v-flex>
                                            </v-layout>
                                        </v-container>
                                    </v-card-text>

                                    <v-card-actions>
                                        <v-spacer></v-spacer>
                                        <v-btn
                                            color="teal darken-3"
                                            class="text-none"
                                            text
                                            @click="bShowNotFoundAlert = false"
                                        >OK</v-btn>
                                    </v-card-actions>
                                </v-card>
                            </v-dialog>
                        </v-layout>
                        <!-- Termina modal para informar que no hubo resultados en la búsqueda *************************** -->

                        <!-- Modal para pedir que se seleccione al menos un idioma: *********************************** -->
                        <v-layout row justify-center>
                            <v-dialog v-model="bDlgNoLangWarning" persistent :width="errorModalWidth">
                                <v-card class="grey lighten-4">
                                    <v-toolbar dense color="teal" dark flat>
                                        <v-toolbar-title
                                            class="my-list-title"
                                        >Selección de Idioma</v-toolbar-title>
                                        <v-spacer></v-spacer>
                                        <v-icon>mdi-alert-circle-outline</v-icon>
                                    </v-toolbar>
                                    <v-card-title class="text-center">
                                        <div style="margin: auto">
                                            <v-icon large color="orange darken-2"
                                                >mdi-alert-circle
                                            </v-icon>
                                        </div>
                                        Por favor seleccione al menos un idioma para este caso.
                                    </v-card-title>

                                    <v-card-actions>
                                        <v-spacer></v-spacer>
                                        <v-btn
                                            color="teal darken-3"
                                            class="text-none"
                                            text
                                            @click="bDlgNoLangWarning = false"
                                        >OK</v-btn>
                                    </v-card-actions>
                                </v-card>
                            </v-dialog>
                        </v-layout>
                        <!-- Termina modal para pedir que se seleccione al menos un idioma *********************************** -->

                        <!-- Modal para pedir que se introduzcan todos los campos obligatorios: *********************************** -->
                        <v-layout row justify-center>
                            <v-dialog v-model="bInvalidData" persistent :width="errorModalWidth">
                                <v-card class="grey lighten-4">
                                    <v-toolbar dense color="teal" dark flat>
                                        <v-toolbar-title
                                            class="my-list-title"
                                        >Información Incompleta</v-toolbar-title>
                                        <v-spacer></v-spacer>
                                        <v-icon>mdi-alert-circle-outline</v-icon>
                                    </v-toolbar>
                                    <v-card-title class="text-center pb-1">
                                        <div style="margin: auto">
                                            <v-icon large color="orange darken-2"
                                                >mdi-alert-circle
                                            </v-icon>
                                        </div>
                                       
                                    </v-card-title>
                                    <v-card-title class="text-center pt-1">
                                        <div style="margin: auto">
                                            {{ errorMessage }}
                                        </div>
                                    </v-card-title>

                                    <v-card-actions>
                                        <v-spacer></v-spacer>
                                        <v-btn
                                            color="teal darken-3"
                                            class="text-none"
                                            text
                                            @click="bInvalidData = false"
                                        >OK</v-btn>
                                    </v-card-actions>
                                </v-card>
                            </v-dialog>
                        </v-layout>
                        <!-- Termina modal para pedir que se introduzcan todos los campos *********************************** -->

                        <!-- Modal para informar que no se puede borrar un cuestionario: *********************************** -->
                        <v-layout row justify-center>
                            <v-dialog
                                v-model="bQuestionnaireNotDeleted"
                                persistent
                                :width="errorModalWidth"
                            >
                                <v-card class="grey lighten-4">
                                    <v-toolbar dense color="teal" dark flat>
                                        <v-toolbar-title
                                            class="my-list-title"
                                        >Caso no borrado</v-toolbar-title>
                                        <v-spacer></v-spacer>
                                        <v-icon>mdi-alert-circle-outline</v-icon>
                                    </v-toolbar>
                                    <v-card-title>
                                        <v-container>
                                            <v-layout row>
                                                <v-flex xs12 class="d-flex justify-center">
                                                    <v-icon
                                                        large
                                                        color="orange darken-2"
                                                    >mdi-alert-circle</v-icon>
                                                </v-flex>
                                            </v-layout>
                                            <v-layout row>
                                                <v-flex
                                                    xs12
                                                    class="d-flex justify-center text-center"
                                                >No es posible borrar el caso seleccionado, ya que está registrado en una encuesta.</v-flex>
                                            </v-layout>
                                        </v-container>
                                    </v-card-title>

                                    <v-card-actions>
                                        <v-spacer></v-spacer>
                                        <v-btn
                                            color="teal darken-3"
                                            class="text-none"
                                            text
                                            @click="bQuestionnaireNotDeleted = false"
                                        >OK</v-btn>
                                    </v-card-actions>
                                </v-card>
                            </v-dialog>
                        </v-layout>
                        <!-- Termina modal para informar que no se puede borrar un cuestionario *********************************** -->

                        <!-- Modal para pedir que se introduzca un número válido: *********************************** -->
                        <v-layout row justify-center>
                            <v-dialog v-model="bDlgInvalidNumber" persistent :width="errorModalWidth">
                                <v-card class="grey lighten-4">
                                    <v-toolbar dense color="teal" dark flat>
                                        <v-toolbar-title
                                            class="my-list-title"
                                        >Evaluación para la respuesta alterna</v-toolbar-title>
                                        <v-spacer></v-spacer>
                                        <v-icon>mdi-alert-circle-outline</v-icon>
                                    </v-toolbar>
                                    <v-card-title class="text-center">
                                       <div style="margin: auto">
                                            <v-icon large color="orange darken-2"
                                                >mdi-alert-circle
                                            </v-icon>
                                       </div>
                                       Por favor introduzca un número válido.
                                    </v-card-title>
                                    
                                    <v-card-actions>
                                        <v-spacer></v-spacer>
                                        <v-btn
                                            color="teal darken-3"
                                            class="text-none"
                                            text
                                            @click="bDlgInvalidNumber = false"
                                        >OK</v-btn>
                                    </v-card-actions>
                                </v-card>
                            </v-dialog>
                        </v-layout>
                        <!-- Termina modal para pedir que se introduzca un número válido *********************************** -->

                        <!-- Modal para confirmar borrado de situación: **************************************** -->
                        <v-layout row justify-center>
                            <v-dialog v-model="bDlgDeletingSituation" persistent max-width="35%">
                                <v-card class="grey lighten-4">
                                    <v-toolbar dense color="orange darken-2" dark flat>
                                        <v-toolbar-title class="my-list-title">Borrar Situación</v-toolbar-title>
                                        <v-spacer></v-spacer>
                                        <v-icon>mdi-delete-forever</v-icon>
                                    </v-toolbar>
                                    <v-card-title class="text-center">
                                        <div style="margin: auto">
                                            <v-icon large color="orange darken-2">mdi-alert</v-icon>
                                        </div>
                                        &nbsp; ¿Desea borrar la situación seleccionada?
                                    </v-card-title>
                                    
                                    <v-card-actions>
                                        <v-spacer></v-spacer>
                                        <v-btn
                                            color="teal darken-3"
                                            class="text-none"
                                            text
                                            @click="confirmDeleteSituation"
                                        >OK</v-btn>
                                        <v-btn
                                            color="pink darken-1"
                                            class="text-none"
                                            text
                                            @click="cancelDeleteSituation"
                                        >Cancelar</v-btn>
                                    </v-card-actions>
                                </v-card>
                            </v-dialog>
                        </v-layout>
                        <!-- Termina Modal para confirmar borrado de situación *************************** -->

                        <!-- Modal para confirmar borrado de autoevaluación: **************************************** -->
                        <v-layout row justify-center>
                            <v-dialog v-model="bDlgDeletingAutoevaluation" persistent max-width="35%">
                                <v-card class="grey lighten-4">
                                    <v-toolbar dense color="orange darken-2" dark flat>
                                        <v-toolbar-title class="my-list-title">Borrar Autoevaluación</v-toolbar-title>
                                        <v-spacer></v-spacer>
                                        <v-icon>mdi-delete-forever</v-icon>
                                    </v-toolbar>
                                    <v-card-title class="text-center">
                                        <div style="margin: auto">
                                            <v-icon large color="orange darken-2">mdi-alert</v-icon>
                                        </div>
                                        &nbsp; ¿Desea borrar la autoevaluación seleccionada?
                                    </v-card-title>
                                    
                                    <v-card-actions>
                                        <v-spacer></v-spacer>
                                        <v-btn
                                            color="teal darken-3"
                                            class="text-none"
                                            text
                                            @click="confirmDeleteAutoevaluation"
                                        >OK</v-btn>
                                        <v-btn
                                            color="pink darken-1"
                                            class="text-none"
                                            text
                                            @click="cancelDeleteAutoevaluation"
                                        >Cancelar</v-btn>
                                    </v-card-actions>
                                </v-card>
                            </v-dialog>
                        </v-layout>
                        <!-- Termina Modal para confirmar borrado de autoevaluación *************************** -->

                        <!-- Modal para confirmar borrado de pregunta: **************************************** -->
                        <v-layout row justify-center>
                            <v-dialog v-model="bDlgDeletingAnswer" persistent max-width="35%">
                                <v-card class="grey lighten-4">
                                    <v-toolbar dense color="orange darken-2" dark flat>
                                        <v-toolbar-title class="my-list-title">Borrar Pregunta</v-toolbar-title>
                                        <v-spacer></v-spacer>
                                        <v-icon>mdi-delete-forever</v-icon>
                                    </v-toolbar>
                                    <v-card-title class="text-center">
                                        <div style="margin: auto">
                                            <v-icon large color="orange darken-2">mdi-alert</v-icon>
                                        </div>
                                        &nbsp; ¿Desea borrar la pregunta seleccionada?
                                    </v-card-title>
                                    
                                    <v-card-actions>
                                        <v-spacer></v-spacer>
                                        <v-btn
                                            color="teal darken-3"
                                            class="text-none"
                                            text
                                            @click="confirmDeleteAnswer"
                                        >OK</v-btn>
                                        <v-btn
                                            color="pink darken-1"
                                            class="text-none"
                                            text
                                            @click="cancelDeleteAnswer"
                                        >Cancelar</v-btn>
                                    </v-card-actions>
                                </v-card>
                            </v-dialog>
                        </v-layout>
                        <!-- Termina Modal para confirmar borrado de pregunta *************************** -->

                        <!-- Termina renglón único para lista de cuestionarios y cuestionario seleccionado -->
                    </v-container>
                    <!-- Termina container para lista de cuestionarios y cuestionario seleccionado -->
                </div>
            </v-flex>
            <!-- Fin Flex para la ventana **************************************************************** -->
        </v-layout>
        <!-- Fin Layout para toda la página *********************************************************** -->
        <v-overlay :value="waitCursor">
            <v-progress-circular indeterminate size="64"></v-progress-circular>
        </v-overlay>
    </v-container>
    <!-- Fin container para toda la página ********************************************* -->
</template>
<script>
import { mapGetters } from 'vuex';

export default {
    name: 'questionnaires',
    data() {
        return {
            bDense: false,
            drawer: false,
            bEdit: false,
            bNew: false,
            
            questionnaireID: 0,
            name: '',
            languageID: 0,
            bInvalidData: false,
            errorMessage: '',

            bDlgNoLangWarning: false,
            languageIDtoDelete: 0,
            bDlgDeletingLanguage: false,
            bDlgEditIntro: false,
            bDlgEditSituationName: false,
            editingSituationNumber: 0,
            editingSituationID: 0,

            bDlgEditAutoevaluation: false,
            editingAutoevaluationID: 0,
            bDlgInvalidNumber: false,

            editingAnswerNumber: 0,
            editingAnswerID: 0,
            questionnaireLangTable: [], //Arreglo con todos los idiomas del caso seleccionado.
            questionnaireIntroArray: [], //Arreglo con la introducción del cuestionario en todos los idiomas, para su edición.
            situationNameArray: [], //Arreglo con el nombre de la situación seleccionada en todos los idiomas.
            answerLangArray: [], //Arreglo con la respuesta seleccionada en todos los idiomas.
            autoevaluationTextArray: [], //Arreglo con el texto de la autoevaluación de la situación seleccionada en todos los idiomas.

            selectedQuestionnaireName: '',
            questionnaireNameTitle: '', //Nombre del caso seleccionado a desplegar en la toolbar del caso.
            selectedQuestionnaireNumber: 0,
            bDeletingQuestionnaire: false,
            answers: [], //Respuestas del idioma seleccionado.
            searchText: '',
            bShowNotFoundAlert: false, //Indica si se debe mostrar el diálogo que indica que no hubo resultados en la búsqueda.
            bQuestionnaireNotDeleted: false, //Indica si se debe mostrar el warning que indica que no se pudo borrar un cuestionario.
            bDlgDeletingSituation: false,
            bDlgDeletingAutoevaluation: false,
            bDlgDeletingAnswer: false,
            situationToDeleteID: 0,
            answerToDeleteID: 0,

            selectedAnswer: [], //Indica la respuesta seleccionada de la tabla.
            bDeletingAnswer: false,
            bDlgEditAnswer: false,
            bDlgEditPrioritizedAnswer: false,

            selectedAnswerTxt: '',
            selectedAnswerID: 0,

            noAnswersText: 'No hay respuestas para el idioma seleccionado.',
            newQuestionnaireFile: null, //Archivo cargado por el file input, para agregar un cuestionario nuevo.
    

            //Parámetros de la evaluación de una respuesta normal a editar:
            respAnalisis: 0,
            respCostoBeneficio: 0,
            respLargoPlazo: 0,
            respPensamientoConceptual: 0,
            respInterpersonal: 0,
            respRelacionamiento: 0,
            respSocial: 0,
            respAutoconocimiento: 0,
            respAjuste: 0,
            respEtica: 0,

            //Parámetros de la evaluación de una respuesta priorizada a editar:
            relEstrategico0: 0,
            relEstrategico1: 0,
            relEstrategico3: 0,
            relEstrategico5: 0,
            relSocial0: 0,
            relSocial1: 0,
            relSocial3: 0,
            relSocial5: 0,

            autoEvalType: '0', //Tipo de autoevaluación, 0 = Respuesta alterna, 1 = Info. complementaria.
            bDisableExitAutoEval: false, //Evita que el usuario presione OK o Cancelar en el modal de edición de autoevaluación cuando
                                        //se está editando un parámetro de la tabla de respuesta alterna.

            autoEvalHeader: [
                {
                    text: '',
                    sortable: false,
                    align: 'right',
                    value: 'respuesta',
                },
                {
                    text: 'Mejor',
                    sortable: false,
                    align: 'center',
                    value: 'mejor',
                },
                {
                    text: 'Similar',
                    sortable: false,
                    align: 'center',
                    value: 'similar'
                },
                {
                    text: 'Menos 1',
                    sortable: false,
                    align: 'center',
                    value: 'menos1'
                },
                {
                    text: 'Menos 2',
                    sortable: false,
                    align: 'center',
                    value: 'menos2'
                },
            ],

            autoEvalTableValues: [
                {
                    row: 0,
                    respuesta: 'Mejor',
                    mejor: '0',
                    similar: '0',
                    menos1: '0',
                    menos2: '0'
                },
                {
                    row: 1,
                    respuesta: 'Muy similar',
                    mejor: '0',
                    similar: '0',
                    menos1: '0',
                    menos2: '0'
                },
                {
                    row: 2,
                    respuesta: 'No tan buena. Omití un punto',
                    mejor: '0',
                    similar: '0',
                    menos1: '0',
                    menos2: '0'
                },
                {
                    row: 3,
                    respuesta: 'No tan buena. Omití más de un punto',
                    mejor: '0',
                    similar: '0',
                    menos1: '0',
                    menos2: '0'
                }
            ],

            mantengoBien: 0,
            mantengoMal: 0,
            cambioBien: 0,
            cambioMal: 0
        };
    },
    created() {
        this.$store.dispatch('initQuestionnaireData'); //Se inicializan los campos del caso.
        this.selectFirstQuestionnaire();
    },
    methods: {
        onClose() {
            this.$router.push('/');
        },
        onNewQuestionnaire()
        {
            this.bEdit = true;
            this.bNew = true;

            this.questionnaireID = 0;
            this.questionnaireNameTitle = 'Nuevo Caso';
            this.selectedQuestionnaireName = '';
            this.selectedQuestionnaireIndex = -1;

            this.$store.dispatch('initQuestionnaireData');
            this.$store.dispatch('createQuestionnaireInfo');
            this.createLanguagesArray();

            console.log("questionnaireLanguages = ", this.questionnaireLanguages);
            console.log("questionnaireIntros = ", this.questionnaireIntros);
            console.log("questionnaireIntroTable = ", this.questionnaireIntroTable);
        },

        onEditQuestionnaire()
        {
            this.bEdit = true;
            this.bNew = false;
        },

        onSelectLanguage(languageID, bSelected)
        {
            console.log("LanguageID = ", languageID);
            console.log("bSelected = ", bSelected);

            //Si se seleccionó un idioma que antes no estaba seleccionado, se crea un nuevo registro para las Intros.:
            if (bSelected)
            {
                //Se agrega el idioma al arreglo questionnaireLanguages:
                var bLangFound = false;
                var i;
                for (i = 0; i < this.questionnaireLanguages.length; i ++)
                {
                    //Checa si el idioma no había sido agregado antes (esto nunca debería pasar si estamos en este punto):
                    if (this.questionnaireLanguages[i].idiomaid === languageID)
                    {
                        bLangFound = true;
                        break;
                    }
                }
                if (!bLangFound)
                {
                    var lang = {
                        idiomaid: languageID
                    }
                    this.questionnaireLanguages.push(lang);
                }

                bLangFound = false;
                for (i = 0; i < this.questionnaireIntros.length; i ++)
                {
                    //Si el idioma ya estaba seleccionado antes, no hace nada (esto nunca debería pasar, ya que si estamos en este punto
                    //quiere decir que antes el idioma no estaba seleccionado)
                    if (this.questionnaireIntros[i].idiomaid === languageID)
                    {
                        bLangFound = true;
                        break;
                    }
                }

                if (!bLangFound)
                {
                    //Crea nuevos elementos en los diferentes arreglos:
                    var newIntroLang = {
                        intro: '',
                        idiomaid: languageID,
                    }
                    this.questionnaireIntros.push(newIntroLang);

                    var j;
                    for (j = 0; j < this.questionnaireSituations.length; j ++)
                    {
                        var newSituationLang = {
                            idiomaid: languageID,
                            situacionid: this.questionnaireSituations[j].situacionid,
                            situacion: ''
                        }
                        this.questionnaireSituationsLang.push(newSituationLang);
                    }

                    for (j = 0; j < this.questionnaireAnswers.length; j++)
                    {
                        var newQuestAnsLang = {
                            idiomaid: languageID,
                            respuestaid: this.questionnaireAnswers[j].respuestaid,
                            respuesta: ''
                        }
                        this.questionnaireAnswersLang.push(newQuestAnsLang);
                    }

                    for (j = 0; j < this.questionnaireAutoevaluations.length; j ++)
                    {
                        var newAutoevalLang = {
                            idiomaid: languageID,
                            autoevaluacionid: this.questionnaireAutoevaluations[j].autoevaluacionid,
                            autoevaluacion: ''
                        }
                        this.questionnaireAutoevaluationsLang.push(newAutoevalLang);
                    }

                    this.$store.dispatch('createQuestionnaireInfo');
                }
            }
            //Si se desseleccionó un idioma, se hace una pregunta para confirmar si se quiere borrar el regitro de la Intro. para ese idioma:
            else // if (!bSelected)
            {
                this.languageIDtoDelete = languageID;
                this.bDlgDeletingLanguage = true;
            }
        },
        onConfirmUnselectLanguage(bDelete)
        {
            if (bDelete)
            {
                var i;

                for (i = 0; i < this.questionnaireLanguages.length; i ++)
                {
                    if (this.questionnaireLanguages[i].idiomaid === this.languageIDtoDelete)
                    {
                        this.questionnaireLanguages.splice(i, 1);
                        break;
                    }
                }

                for (i = 0; i < this.questionnaireIntros.length; i ++)
                {
                    if (this.questionnaireIntros[i].idiomaid === this.languageIDtoDelete)
                    {
                        this.questionnaireIntros.splice(i, 1);
                        break;
                    }
                }

                var sitLangSize = this.questionnaireSituationsLang.length;
                for (i = 0; i < sitLangSize; i ++)
                {
                    if (this.questionnaireSituationsLang[i].idiomaid === this.languageIDtoDelete)
                    {
                        this.questionnaireSituationsLang.splice(i, 1);
                        i = i -1;
                        sitLangSize -= 1;
                    }
                }

                var ansLangSize = this.questionnaireAnswersLang.length;
                for (i = 0; i < ansLangSize; i ++)
                {
                    if (this.questionnaireAnswersLang[i].idiomaid === this.languageIDtoDelete)
                    {
                        this.questionnaireAnswersLang.splice(i, 1);
                        i = i - 1;
                        ansLangSize -= 1;
                    }
                }

                var autoevalLangSize = this.questionnaireAutoevaluationsLang.length;
                for (i = 0; i < autoevalLangSize; i ++)
                {
                    if (this.questionnaireAutoevaluationsLang[i].idiomaid === this.languageIDtoDelete)
                    {
                        this.questionnaireAutoevaluationsLang.splice(i, 1);
                        i = i - 1;
                        autoevalLangSize -= 1;
                    }
                }

                //console.log("questionnaireSituationsLang = ", this.questionnaireSituationsLang);

                this.$store.dispatch('createQuestionnaireInfo');
            }
            else
            {
                //Se vuelve a seleccionar el idioma que se había desseleccionado:
                var i;
                for (i = 0; i < this.questionnaireLangTable.length; i ++)
                {
                    if (this.questionnaireLangTable[i].languageID === this.languageIDtoDelete)
                    {
                        this.questionnaireLangTable[i].selected = true;
                        break;
                    }
                }
            }
            this.bDlgDeletingLanguage = false;
            this.languageIDtoDelete = 0;
        },

        onDeleteQuestionnaire() {
            this.bDeletingQuestionnaire = true;
        },
        cancelDeleteQuestionnaire() {
            this.bDeletingQuestionnaire = false;
        },
        deleteQuestionnaireConfirmed() {
            this.bDeletingQuestionnaire = false;

            //Como el borrado en el servidor es asíncrono, antes de borrar el registro en el servidor se borra
            //el registro localmente. Si no, si el registro borrado era el primer registro, si primero se
            //borra en el servidor y después se selecciona el primer registro, es posible que se vuelva a
            //seleccionar el registro borrado antes de que éste se borre en el servidor.

            // var i;
            // for (i = 0; i < this.questionnaires.length; i++) {
            //     if (this.questionnaires[i].id === this.questionnaireID) {
            //         this.questionnaires.splice(i, 1);
            //         break;
            //     }
            // }

            this.$store.dispatch('deleteQuestionnaire', this.questionnaireID);
            //this.selectFirstQuestionnaire();
        },

        selectFirstQuestionnaire() {
            //console.log('selectFistSet, ', this.questionnaires);
            if (this.questionnaires.length > 0)
            {
                this.selectedQuestionnaireIndex = 0;
                var questionnaireID = this.questionnaires[this.selectedQuestionnaireIndex].id;
                this.selectQuestionnaire(questionnaireID);
            }
            else
            {
                this.selectedQuestionnaireIndex = -1;
                this.questionnaireID = 0;
            }
        },

        selectQuestionnaire(questionnaireID)
        {
            
            //console.log("en selectQuestionnaire, questionnaires = ", this.questionnaires);

            var i;
            for (i = 0; i < this.questionnaires.length; i++)
            {
                if (this.questionnaires[i].id === questionnaireID)
                {
                    this.questionnaireID = questionnaireID;

                    this.selectedQuestionnaireName = this.questionnaires[i].titulo;
                    this.selectedQuestionnaireNumber = this.questionnaires[i].numero;
                    this.questionnaireNameTitle = this.selectedQuestionnaireName;
                    this.noAnswersText = 'No hay respuestas para la situación seleccionada.';
                    this.loadingQuestionnaire = true; //Para no dejar seleccionar otro caso antes de que se haya terminado de cargar toda la información.
                    this.$store.dispatch('getQuestionnaireData', questionnaireID);
                    break;
                }
            }
            
        },

        createLanguagesArray()
        {
            //Crea un arreglo con los idiomas registrados en el sistema:
            this.questionnaireLangTable = [];
            var i;
            for (i = 0; i < this.languages.length; i++)
            {
                var lang = {
                    languageID: this.languages[i].idiomaid,
                    langName:  this.languages[i].idioma,
                    selected: false,
                };

                //Se busca si el idioma está seleccionado en el cuestionario:
                var j;
                for (j = 0; j < this.questionnaireLanguages.length; j++)
                {
                    if (lang.languageID === this.questionnaireLanguages[j].idiomaid)
                    {
                        lang.selected = true;
                        break;
                    }
                }
                this.questionnaireLangTable.push(lang);
            }
        },

        generateIndexedAnswers(answers) {
            //Se genera el arreglo local con las respuestas del idioma seleccionado, con un índice para saber qué
            //número de respuesta es:

            this.answers = [];

            var i;
            for (i = 0; i < answers.length; i++) {
                const answer = {
                    index: i + 1,
                    id: answers[i].id,
                    respuesta: answers[i].respuesta
                };
                this.answers.push(answer);
            }
        },

        onEditIntro() {
            if (this.questionnaireLanguages.length === 0)
            {
                this.bDlgNoLangWarning = true;
            }
            else
            {
                //Se crea un arreglo con la intro. del cuestionario en todos los idiomas configurados:
                console.log("questionnaireIntros = ", this.questionnaireIntros);
                this.questionnaireIntroArray = [];
                var i;
                for (i = 0; i < this.questionnaireIntros.length; i++) {
                    var LangIntro = {
                        intro: this.questionnaireIntros[i].intro,
                        languageID: this.questionnaireIntros[i].idiomaid,
                        languageName: ''
                    };
                    var j;
                    for (j = 0; j < this.languages.length; j++) {
                        if (this.questionnaireIntros[i].idiomaid === this.languages[j].idiomaid)
                        {
                            LangIntro.languageName = this.languages[j].idioma;
                            break;
                        }
                    }
                    this.questionnaireIntroArray.push(LangIntro);
                }

                console.log("questionnaireIntroArray = ", this.questionnaireIntroArray);

                this.bDlgEditIntro = true;
            }
        },

        onCancelIntroEdition() {
            this.bDlgEditIntro = false;
        },

        onConfirmIntroEdition() {
            //Edita el arreglo de introducciones del cuestionario en los diferentes idiomas:
            var i;
            for (i = 0; i < this.questionnaireIntroArray.length; i++)
            {
                var j;
                for (j = 0; j < this.questionnaireIntros.length; j++)
                {
                    if (this.questionnaireIntroArray[i].languageID === this.questionnaireIntros[j].idiomaid)
                    {
                        this.questionnaireIntros[j].intro = this.questionnaireIntroArray[i].intro;

                        //Se edita el único renglón que tiene la tabla questionnaireIntroTable:
                        const idiomaid = this.questionnaireIntroArray[i].languageID;
                        this.questionnaireIntroTable[0][idiomaid] = this.questionnaireIntroArray[i].intro;
                        break;
                    }
                }
            }

            //PENDIENTE:
            //this.$store.dispatch('updateQuestionnaireIntros', questionnaireToEdit);
            this.bDlgEditIntro = false;
        },

        onNewSituation()
        {
            if (this.questionnaireLanguages.length === 0)
            {
                this.bDlgNoLangWarning = true;
            }
            else
            {
                //Obtiene el ID y el número para la nueva situación:
                var i;
                var newSituationID = 0;
                var newSituationNumber = 0;
                for (i = 0; i < this.questionnaireSituations.length; i ++)
                {
                    //Puede haber otras situaciones nuevas, por lo que puede haber negativas.
                    if (newSituationID < Math.abs(this.questionnaireSituations[i].situacionid))
                    {
                        newSituationID = Math.abs(this.questionnaireSituations[i].situacionid);
                    }

                    //Si la situación del arreglo que se está recorriendo es del caso en edición, se suma
                    //al número de situaciones del caso:
                    if (this.questionnaireSituations[i].casoid === this.questionnaireID)
                    {
                        newSituationNumber ++;
                    }
                }

                //Como es un ID temporal (pero se requiere por las tablas), ya que el definitivo lo asignará el servidor, se pone negativo:
                newSituationID = - (newSituationID + 1);
                this.editingSituationID = newSituationID;
                newSituationNumber ++;

                var newSituation = {
                    situacionid: newSituationID,
                    casoid: this.questionnaireID,//Temporalmente, ID se asigna por el servidor.
                    numero: newSituationNumber,
                    tipoSituacion: "1" //Default.
                }

                this.questionnaireSituations.push(newSituation);

                //Se crea un elemento en el arreglo SituacionesIdiomas por cada idioma del caso:
                for (i = 0; i < this.questionnaireLanguages.length; i ++)
                {
                    var newSituationLang = {
                        idiomaid: this.questionnaireLanguages[i].idiomaid,
                        situacionid: newSituation.situacionid,
                        situacion: ''
                    }

                    this.questionnaireSituationsLang.push(newSituationLang);
                }

                this.$store.dispatch('createQuestionnaireInfo');
            }
        },

        editSituation(situationID, situationNumber) {
            //console.log('situation: ', situationID);
            //console.log('languages: ', this.languages.length);

            this.editingSituationID = situationID;
            this.editingSituationNumber = situationNumber;

            //Se crea un arreglo con el nombre de la situación en todos los idiomas configurados:

            this.situationNameArray = [];

            var i;
            for (i = 0; i < this.questionnaireSituationsLang.length; i++) {
                if (this.questionnaireSituationsLang[i].situacionid === situationID) {
                    var name = {
                        name: this.questionnaireSituationsLang[i].situacion,
                        languageID: this.questionnaireSituationsLang[i].idiomaid,
                        languageName: ''
                    };

                    var j;
                    for (j = 0; j < this.languages.length; j++) {
                        if (this.questionnaireSituationsLang[i].idiomaid === this.languages[j].idiomaid)
                        {
                            name.languageName = this.languages[j].idioma;
                            break;
                        }
                    }
                    this.situationNameArray.push(name);
                }
            }

            this.bDlgEditSituationName = true;

            //console.log("questionnaireSituationsLang = ", this.questionnaireSituationsLang);
            //console.log("situationNameArray = ", this.situationNameArray);
        },

        onCancelSituationEdition() {
            this.bDlgEditSituationName = false;
        },

        onConfirmSituationEdition() {
            //Edita el arreglo de los textos de la situación en los diferentes idiomas:

            //console.log('situationNameArray = ', this.situationNameArray);
            //console.log('editingSituationID = ', this.editingSituationID);
            //console.log('questionnaireSituationTable = ', this.questionnaireSituationTable);
            //console.log('questionnaireSituationTable[0][0] = ', this.questionnaireSituationTable[0][0][1]);

            // var temp1 = JSON.parse(JSON.stringify(this.questionnaireSituationTable));

            var i;
            for (i = 0; i < this.situationNameArray.length; i++)
            {
                var j;
                for (j = 0; j < this.questionnaireSituationsLang.length; j++)
                {
                    if (this.questionnaireSituationsLang[j].situacionid === this.editingSituationID &&
                        this.situationNameArray[i].languageID === this.questionnaireSituationsLang[j].idiomaid)
                    {
                        this.questionnaireSituationsLang[j].situacion = this.situationNameArray[i].name;

                        //Se edita tabla questionnaireSituationTable, en el elemento 0 del renglón que contiene la situación editada:
                        var k;
                        for (k = 0; k < this.questionnaireSituationTable.length; k++)
                        {
                            if (this.questionnaireSituationTable[k][0].id === this.editingSituationID)
                            {
                                const idiomaid = this.situationNameArray[i].languageID;
                                this.questionnaireSituationTable[k][0][idiomaid] = this.situationNameArray[i].name;
                                break;
                            }
                        }
                    }
                }
            }

            //console.log('questionnaires = ', this.questionnaires);
            //PENDIENTE:
            //this.$store.dispatch('updateQuestionnaireSituations');

            this.bDlgEditSituationName = false;

            // var temp2 = JSON.parse(JSON.stringify(this.questionnaireSituationTable));
        },

        onDeleteSituation(situationID, situationNumber)
        {
            this.situationToDeleteID = situationID;
            this.editingSituationNumber = situationNumber;
            this.bDlgDeletingSituation = true;
        },

        cancelDeleteSituation()
        {
            this.situationToDeleteID = 0;
            this.bDlgDeletingSituation = false;
        },

        confirmDeleteSituation()
        {
            this.deleteSituation(this.situationToDeleteID);
            this.deleteSituationAnswers(this.situationToDeleteID);
            this.deleteAutoevaluation(this.situationToDeleteID);

            this.situationToDeleteID = 0;
            this.bDlgDeletingSituation = false;

            // console.log("questionnaireSituations = ", this.questionnaireSituations);
            // console.log("questionnaireSituationsLang = ", this.questionnaireSituationsLang);
            // console.log("questionnaireAnswers = ", this.questionnaireAnswers);
            // console.log("questionnaireAnswersLang = ", this.questionnaireAnswersLang);
            // console.log("questionnaireAutoevaluations = ", this.questionnaireAutoevaluations);
            // console.log("questionnaireAutoEvaluationsLang = ", this.questionnaireAutoevaluationsLang);

            this.$store.dispatch('createQuestionnaireInfo');

        },

        deleteSituation(situationID)
        {
            //Borra la situación y sus textos en todos los idiomas:
            var sitLangSize = this.questionnaireSituationsLang.length;
            var i;
            for (i = 0; i < sitLangSize; i ++)
            {
                if (this.questionnaireSituationsLang[i].situacionid === situationID)
                {
                    this.questionnaireSituationsLang.splice(i, 1);
                    i --;
                    sitLangSize --;
                }
            }

            console.log("editingSituationNumber = ", this.editingSituationNumber);

            var situationsSize = this.questionnaireSituations.length;
            for (i = 0; i < situationsSize; i ++)
            {
                if (this.questionnaireSituations[i].situacionid === situationID)
                {
                    this.questionnaireSituations.splice(i, 1);
                    i --;
                    situationsSize --;
                }
                else
                //Disminuye el número de situación de las situaciones mayores:
                if (this.questionnaireSituations[i].numero > this.editingSituationNumber)
                {
                    this.questionnaireSituations[i].numero --;
                }
            }
        },

        deleteSituationAnswers(situationID)
        {
            //Borra todas las respuestas de una situación y sus textos en todos los idiomas:

            var ansSize = this.questionnaireAnswers.length;
            var i;
            for (i = 0; i < ansSize; i ++)
            {
                if (this.questionnaireAnswers[i].situacionid === situationID)
                {
                    var ansLangSize = this.questionnaireAnswersLang.length;
                    var j;
                    for (j = 0; j < ansLangSize; j ++)
                    {
                        if (this.questionnaireAnswersLang[j].respuestaid === this.questionnaireAnswers[i].respuestaid)
                        {
                            this.questionnaireAnswersLang.splice(j, 1);
                            j --;
                            ansLangSize --;
                        }
                    }
                    this.questionnaireAnswers.splice(i, 1);
                    i --;
                    ansSize --;
                }
            }
        },

        deleteAutoevaluation(situationID)
        {
            //Borra la autoevaluación de una situación y sus textos en todos los idiomas:
           var i;
            for (i = 0; i < this.questionnaireAutoevaluations.length; i ++)
            {
                if (this.questionnaireAutoevaluations[i].situacionid === situationID)
                {
                    var autoevalLangSize = this.questionnaireAutoevaluationsLang.length;
                    var j;
                    for (j = 0; j < autoevalLangSize; j ++)
                    {
                        if (this.questionnaireAutoevaluationsLang[j].autoevaluacionid === this.questionnaireAutoevaluations[i].autoevaluacionid)
                        {
                            this.questionnaireAutoevaluationsLang.splice(j, 1);
                            j --;
                            autoevalLangSize --;
                        }
                    }
                    this.questionnaireAutoevaluations.splice(i, 1);
                    break;
                }
            }
        },

        onNewAnswer(situationID)
        {
            //Obtiene el ID para la nueva respuesta:
            var i;
            var newAnswerID = 0;
            var newAnswerNumber = 0;
            for (i = 0; i < this.questionnaireAnswers.length; i ++)
            {
                 //Puede haber otras respuestas nuevas, por lo que puede haber negativas.
                if (newAnswerID < Math.abs(this.questionnaireAnswers[i].respuestaid))
                {
                    newAnswerID = Math.abs(this.questionnaireAnswers[i].respuestaid);
                }

                //Si la respuesta del arreglo que se está recorriendo es de la respuesta en edición, se suma
                //al número de respuestas de la situación:
                if (this.questionnaireAnswers[i].situacion === situationID)
                {
                    newAnswerNumber ++;
                }
            }

            //Como es un ID temporal (pero se requiere por las tablas), ya que el definitivo lo asignará el servidor, se pone negativo:
            newAnswerID = - (newAnswerID + 1);
            newAnswerNumber ++;

            var newAnswer = {
                situacionid: situationID,
                respuestaid: newAnswerID,
                analisis: 0,
                costoBeneficio: 0,
                largoPlazo: 0,
                pensamientoConceptual: 0,
                interpersonal: 0,
                relacionamientoEstrategico: 0,
                social: 0,
                autoconocimiento: 0,
                ajuste: 0,
                etica: 0,
                relacionamientoEstrategico0: 0,
                relacionamientoEstrategico1: 1,
                relacionamientoEstrategico3: 3,
                relacionamientoEstrategico5: 5,
                relacionamientoSocial0: 0,
                relacionamientoSocial1: 1,
                relacionamientoSocial3: 3,
                relacionamientoSocial5: 5,
            }

            this.questionnaireAnswers.push(newAnswer);

            //Se crea un elemento en el arreglo RespuestasIdiomas por cada idioma del caso:
            for (i = 0; i < this.questionnaireLanguages.length; i ++)
            {
                var newAnswerLang = {
                    idiomaid: this.questionnaireLanguages[i].idiomaid,
                    respuestaid: newAnswer.respuestaid,
                    respuesta: ''
                }

                this.questionnaireAnswersLang.push(newAnswerLang);
            }

            //console.log("onNewAnswer, questionnaireAnswers = ", this.questionnaireAnswers);
            //console.log("onNewAnswer, questionnaireAnswersLang = ", this.questionnaireAnswersLang);
            //console.log("questionnaireAnswerTable = ", this.questionnaireAnswerTable);

            this.$store.dispatch('createQuestionnaireInfo');
        },

        onNewAutoevaluation(situationID)
        {
            if (this.questionnaireLanguages.length === 0)
            {
                this.bDlgNoLangWarning = true;
            }
            else
            {
                //Obtiene el ID para la nueva autoevaluación:
                var i;
                var newAutoevaluationID = 0;
                for (i = 0; i < this.questionnaireAutoevaluations.length; i ++)
                {
                    //Puede haber otras autoevaluaciones nuevas, por lo que puede haber negativas.
                    if (newAutoevaluationID < Math.abs(this.questionnaireAutoevaluations[i].autoevaluacionid))
                    {
                        newAutoevaluationID = Math.abs(this.questionnaireAutoevaluations[i].autoevaluacionid);
                    }
                }

                //Como es un ID temporal (pero se requiere por las tablas), ya que el definitivo lo asignará el servidor, se pone negativo:
                newAutoevaluationID = - (newAutoevaluationID + 1);

                var newAutoevaluation = {
                    situacionid: situationID,
                    autoevaluacionid: newAutoevaluationID,
                    tipoEvaluacion: 0,
                    mantengoBien: 0,
                    mantengoMal: 0,
                    cambioBien: 0,
                    cambioMal: 0,
                    mejor: [0, 0, 0, 0],
                    muySimilar: [0, 0, 0, 0],
                    omitiUnPunto: [0, 0, 0, 0],
                    omitiDosPuntos: [0, 0, 0, 0]
                }

                this.questionnaireAutoevaluations.push(newAutoevaluation);

                //Se crea un elemento en el arreglo AutoevaluacionesIdiomas por cada idioma del caso:
                for (i = 0; i < this.questionnaireLanguages.length; i ++)
                {
                    var newAutoevalLang = {
                        idiomaid: this.questionnaireLanguages[i].idiomaid,
                        autoevaluacionid: newAutoevaluation.autoevaluacionid,
                        autoevaluacion: ''
                    }

                    this.questionnaireAutoevaluationsLang.push(newAutoevalLang);
                }
            }

            this.$store.dispatch('createQuestionnaireInfo');
        },

        onEditAutoevaluation(situationID, situationNumber) {

            this.editingSituationID = situationID;
            this.editingAutoevaluationID = 0;

            //console.log("onEditAutoevaluation, questionnaireAutoevaluations = ", this.questionnaireAutoevaluations);
            
            //console.log("onEditAutoevaluation, questionnaireAutoevaluationTable = ", this.questionnaireAutoevaluationTable);

            var x;
            for (x = 0; x < this.questionnaireAutoevaluations.length; x ++)
            {
                if (this.questionnaireAutoevaluations[x].situacionid === situationID)
                {
                    this.editingAutoevaluationID = this.questionnaireAutoevaluations[x].autoevaluacionid;
                    this.autoEvalType = (this.questionnaireAutoevaluations[x].tipoEvaluacion).toString();

                    //Obtiene los parámetros del tipo de evaluación:
                    
                    this.autoEvalTableValues[0].mejor = this.questionnaireAutoevaluations[x].mejor[0];
                    this.autoEvalTableValues[0].similar = this.questionnaireAutoevaluations[x].mejor[1];
                    this.autoEvalTableValues[0].menos1 = this.questionnaireAutoevaluations[x].mejor[2];
                    this.autoEvalTableValues[0].menos2 = this.questionnaireAutoevaluations[x].mejor[3];

                    this.autoEvalTableValues[1].mejor = this.questionnaireAutoevaluations[x].muySimilar[0];
                    this.autoEvalTableValues[1].similar = this.questionnaireAutoevaluations[x].muySimilar[1];
                    this.autoEvalTableValues[1].menos1 = this.questionnaireAutoevaluations[x].muySimilar[2];
                    this.autoEvalTableValues[1].menos2 = this.questionnaireAutoevaluations[x].muySimilar[3];

                    this.autoEvalTableValues[2].mejor = this.questionnaireAutoevaluations[x].omitiUnPunto[0];
                    this.autoEvalTableValues[2].similar = this.questionnaireAutoevaluations[x].omitiUnPunto[1];
                    this.autoEvalTableValues[2].menos1 = this.questionnaireAutoevaluations[x].omitiUnPunto[2];
                    this.autoEvalTableValues[2].menos2 = this.questionnaireAutoevaluations[x].omitiUnPunto[3];

                    this.autoEvalTableValues[3].mejor = this.questionnaireAutoevaluations[x].omitiDosPuntos[0];
                    this.autoEvalTableValues[3].similar = this.questionnaireAutoevaluations[x].omitiDosPuntos[1];
                    this.autoEvalTableValues[3].menos1 = this.questionnaireAutoevaluations[x].omitiDosPuntos[2];
                    this.autoEvalTableValues[3].menos2 = this.questionnaireAutoevaluations[x].omitiDosPuntos[3];

                    this.mantengoBien = this.questionnaireAutoevaluations[x].mantengoBien;
                    this.mantengoMal = this.questionnaireAutoevaluations[x].mantengoMal;
                    this.cambioBien = this.questionnaireAutoevaluations[x].cambioBien;
                    this.cambioMal = this.questionnaireAutoevaluations[x].cambioMal;

                    break;
                }
            }

            //console.log("onEditAutoevaluation, editingAutoevaluationID = ", this.editingAutoevaluationID);

            if (this.editingAutoevaluationID !== 0)
            {
                this.editingSituationNumber = situationNumber;

                //Se crea un arreglo con la autoevaluación de la situación en todos los idiomas configurados:

                this.autoevaluationTextArray = [];

                var i;
                for (i = 0; i < this.questionnaireAutoevaluationsLang.length; i++)
                {
                    if (this.questionnaireAutoevaluationsLang[i].autoevaluacionid === this.editingAutoevaluationID) {
                        var autoevalText = {
                            autoeval: this.questionnaireAutoevaluationsLang[i].autoevaluacion,
                            languageID: this.questionnaireAutoevaluationsLang[i].idiomaid,
                            languageName: ''
                        };

                        var j;
                        for (j = 0; j < this.languages.length; j++) {
                            if (
                                this.questionnaireSituationsLang[i].idiomaid ===
                                this.languages[j].idiomaid
                            ) {
                                autoevalText.languageName = this.languages[j].idioma;
                                break;
                            }
                        }
                        this.autoevaluationTextArray.push(autoevalText);
                    }
                }

                //console.log("autoEvalTableValues = ", this.autoEvalTableValues);

                this.bDlgEditAutoevaluation = true;
            }//end if (this.editingAutoevaluationID !== 0)
        },

        saveAutoEvalItem(column, item, value)
        {
            // console.log("item = ", item);
            var iValue = parseInt(value);
            //console.log("value = ", value);
            //console.log("iValue = ", iValue);
            
            if (isNaN(iValue))
            {
                this.bDlgInvalidNumber = true;
                iValue = 0;

                if (column === 0)
                {
                    this.autoEvalTableValues[item.row].mejor = 0;
                }
                else
                if (column === 1)
                {
                    this.autoEvalTableValues[item.row].similar = 0;
                }
                if (column === 2)
                {
                    this.autoEvalTableValues[item.row].menos1 = 0;
                }
                else
                if (column === 3)
                {
                    this.autoEvalTableValues[item.row].menos2 = 0;
                }
            }
            
            //Llena la diagonal:
            if (((item.row === 0) && (column === 0)) || ((item.row === 1) && (column === 1)) ||
                ((item.row === 2) && (column === 2)) || ((item.row === 3) && (column === 3)))
            {
                this.autoEvalTableValues[0].mejor = iValue;
                this.autoEvalTableValues[1].similar = iValue;
                this.autoEvalTableValues[2].menos1 = iValue;
                this.autoEvalTableValues[3].menos2 = iValue;
            }
            else
            //Hace iguales con signo contrario los opuestos por la diagonal:
            if (item.row === 0)
            {
                if (column === 1)
                {
                    this.autoEvalTableValues[1].mejor = -iValue;
                }
                else
                if (column === 2)
                {
                    this.autoEvalTableValues[2].mejor = -iValue;
                }
                else
                if (column === 3)
                {
                    this.autoEvalTableValues[3].mejor = -iValue;
                }
            }
            else
            if (item.row === 1)
            {
                if (column === 0)
                {
                    this.autoEvalTableValues[0].similar = -iValue;
                }
                else
                if (column === 2)
                {
                    this.autoEvalTableValues[2].similar = -iValue;
                }
                else
                if (column === 3)
                {
                    this.autoEvalTableValues[3].similar = -iValue;
                }
            }
            else
            if (item.row === 2)
            {
                if (column === 0)
                {
                    this.autoEvalTableValues[0].menos1 = -iValue;
                }
                else
                if (column === 1)
                {
                    this.autoEvalTableValues[1].menos1 = -iValue;
                }
                else
                if (column === 3)
                {
                    this.autoEvalTableValues[3].menos1 = -iValue;
                }
            }
            else
            if (item.row === 3)
            {
                if (column === 0)
                {
                    this.autoEvalTableValues[0].menos2 = -iValue;
                }
                else
                if (column === 1)
                {
                    this.autoEvalTableValues[1].menos2 = -iValue;
                }
                else
                if (column === 2)
                {
                    this.autoEvalTableValues[2].menos1 = -iValue;
                }
            }
            //console.log("autoEvalTableValues = ", this.autoEvalTableValues);
        },

        cancelAutoEvalItem()
        {},

        openAutoEvalItem()
        {
            //Deshabilita los botones OK y Cancelar del modal para edición de la autoevaluación, para evitar
            //que el usuario presione OK o Cancelar en el botón incorrecto:
            this.bDisableExitAutoEval = true;
        },

        closeAutoEvalItem()
        {
            this.bDisableExitAutoEval = false;
        },

        onCancelAutoevaluationEdition() {
            this.bDlgEditAutoevaluation = false;
        },

        onConfirmAutoevaluationEdition()
        {
            //Edita el arreglo de los textos de la autoevaluación en los diferentes idiomas:

            // console.log("onConfirmAutoEvaluationEdition, this.autoevaluationTextArray", this.autoevaluationTextArray);
            //console.log("onConfirmAutoEvaluationEdition, this.questionnaireAutoevaluationTable = ", this.questionnaireAutoevaluationTable);
            // console.log("onConfirmAutoEvaluationEdition, this.questionnaireAutoevaluationsLang = ", this.questionnaireAutoevaluationsLang);
            // console.log("this.editingAutoevaluationID = ", this.editingAutoevaluationID);

            if (this.bEdit)
            {
                var i;
                for (i = 0; i < this.autoevaluationTextArray.length; i++)
                {
                    var j;
                    for (j = 0; j < this.questionnaireAutoevaluationsLang.length; j++)
                    {
                        if (this.questionnaireAutoevaluationsLang[j].autoevaluacionid === this.editingAutoevaluationID &&
                            this.autoevaluationTextArray[i].languageID === this.questionnaireAutoevaluationsLang[j].idiomaid)
                        {
                            this.questionnaireAutoevaluationsLang[j].autoevaluacion = this.autoevaluationTextArray[i].autoeval;

                            //Se edita tabla questionnaireAutoevaluationTable, en el elemento 0 del renglón que contiene la autoevaluación editada:

                            var k;
                            for (k = 0; k < this.questionnaireAutoevaluationTable.length; k++)
                            {
                                if (this.questionnaireAutoevaluationTable[k][0].situationid === this.editingSituationID)
                                {
                                    const idiomaid = this.autoevaluationTextArray[i].languageID;
                                    this.questionnaireAutoevaluationTable[k][0][idiomaid] = this.autoevaluationTextArray[i].autoeval;
                                    break;
                                }
                            }
                        }
                    }
                }

                //Edita los parámetros de la autoevaluación:
                console.log("this.autoEvalType = ", this.autoEvalType);
                
                for (i = 0; i < this.questionnaireAutoevaluations.length; i ++)
                {
                    if (this.questionnaireAutoevaluations[i].autoevaluacionid === this.editingAutoevaluationID)
                    {
                        this.questionnaireAutoevaluations[i].tipoEvaluacion = this.autoEvalType;

                        this.questionnaireAutoevaluations[i].mantengoBien = this.mantengoBien;
                        this.questionnaireAutoevaluations[i].mantengoMal = this.mantengoMal;
                        this.questionnaireAutoevaluations[i].cambioBien = this.cambioBien;
                        this.questionnaireAutoevaluations[i].cambioMal = this.cambioMal;

                        this.questionnaireAutoevaluations[i].mejor[0] = this.autoEvalTableValues[0].mejor;
                        this.questionnaireAutoevaluations[i].mejor[1] = this.autoEvalTableValues[0].similar;
                        this.questionnaireAutoevaluations[i].mejor[2] = this.autoEvalTableValues[0].menos1;
                        this.questionnaireAutoevaluations[i].mejor[3] = this.autoEvalTableValues[0].menos2;

                        this.questionnaireAutoevaluations[i].muySimilar[0] = this.autoEvalTableValues[1].mejor;
                        this.questionnaireAutoevaluations[i].muySimilar[1] = this.autoEvalTableValues[1].similar;
                        this.questionnaireAutoevaluations[i].muySimilar[2] = this.autoEvalTableValues[1].menos1;
                        this.questionnaireAutoevaluations[i].muySimilar[3] = this.autoEvalTableValues[1].menos2;

                        this.questionnaireAutoevaluations[i].omitiUnPunto[0] = this.autoEvalTableValues[2].mejor;
                        this.questionnaireAutoevaluations[i].omitiUnPunto[1] = this.autoEvalTableValues[2].similar;
                        this.questionnaireAutoevaluations[i].omitiUnPunto[2] = this.autoEvalTableValues[2].menos1;
                        this.questionnaireAutoevaluations[i].omitiUnPunto[3] = this.autoEvalTableValues[2].menos2;

                        this.questionnaireAutoevaluations[i].omitiDosPuntos[0] = this.autoEvalTableValues[3].mejor;
                        this.questionnaireAutoevaluations[i].omitiDosPuntos[1] = this.autoEvalTableValues[3].similar;
                        this.questionnaireAutoevaluations[i].omitiDosPuntos[2] = this.autoEvalTableValues[3].menos1;
                        this.questionnaireAutoevaluations[i].omitiDosPuntos[3] = this.autoEvalTableValues[3].menos2;
                    }
                }

                console.log("this.questionnaireAutoevaluations = ", this.questionnaireAutoevaluations);
                console.log("this.questionnaireAutoevaluationsLang = ", this.questionnaireAutoevaluationsLang);
                //PENDIENTE:
                //this.$store.dispatch('updateQuestionnaireAutoevaluations');
            }

            this.bDlgEditAutoevaluation = false;
        },

        onDeleteAutoevaluation(situationID)
        {
            this.editingSituationID = situationID;
            this.bDlgDeletingAutoevaluation = true;
        },

        cancelDeleteAutoevaluation()
        {
            this.editingSituationID = 0;
            this.bDlgDeletingAutoevaluation = false;
        },

        confirmDeleteAutoevaluation()
        {
            this.deleteAutoevaluation(this.editingSituationID);

            this.editingSituationID = 0;
            this.bDlgDeletingAutoevaluation = false;

            // console.log("questionnaireAutoevaluations = ", this.questionnaireAutoevaluations);
            // console.log("questionnaireAutoEvaluationsLang = ", this.questionnaireAutoevaluationsLang);

            this.$store.dispatch('createQuestionnaireInfo');

        },

        onEditAnswer(situationNumber, item, situationType) {
            //console.log('Editing item:', item);
            
            //console.log('questionnaireAnswersLang: ', this.questionnaireAnswersLang);

            this.editingSituationNumber = situationNumber;
            this.editingAnswerID = item.answerID;
            this.editingAnswerNumber = item.num;

            //Se buscan los parámetros de evaluación de la respuesta:
            var i;
            for (i = 0; i < this.questionnaireAnswers.length; i ++)
            {
                if (this.questionnaireAnswers[i].respuestaid === item.answerID)
                {
                    //Para respuesta normal:
                    this.respAnalisis = this.questionnaireAnswers[i].analisis;
                    this.respCostoBeneficio = this.questionnaireAnswers[i].costoBeneficio;
                    this.respLargoPlazo = this.questionnaireAnswers[i].largoPlazo;
                    this.respPensamientoConceptual = this.questionnaireAnswers[i].pensamientoConceptual;
                    this.respInterpersonal = this.questionnaireAnswers[i].interpersonal;
                    this.respRelacionamiento = this.questionnaireAnswers[i].relacionamientoEstrategico;
                    this.respSocial = this.questionnaireAnswers[i].social;
                    this.respAutoconocimiento = this.questionnaireAnswers[i].autoconocimiento;
                    this.respAjuste = this.questionnaireAnswers[i].ajuste;
                    this.respEtica = this.questionnaireAnswers[i].etica;

                    //Para respuesta priorizada:
                    this.relEstrategico0 = this.questionnaireAnswers[i].relacionamientoEstrategico0;
                    this.relEstrategico1 = this.questionnaireAnswers[i].relacionamientoEstrategico1;
                    this.relEstrategico3 = this.questionnaireAnswers[i].relacionamientoEstrategico3;
                    this.relEstrategico5 = this.questionnaireAnswers[i].relacionamientoEstrategico5;
                    this.relSocial0 = this.questionnaireAnswers[i].relacionamientoSocial0;
                    this.relSocial1 = this.questionnaireAnswers[i].relacionamientoSocial1;
                    this.relSocial3 = this.questionnaireAnswers[i].relacionamientoSocial3;
                    this.relSocial5 = this.questionnaireAnswers[i].relacionamientoSocial5;

                    break;
                }
            }

            //Se crea un arreglo con la respuesta en todos los idiomas configurados:

            this.answerLangArray = [];

            
            for (i = 0; i < this.questionnaireAnswersLang.length; i++)
            {
                if (this.questionnaireAnswersLang[i].respuestaid === item.answerID)
                {
                    var answer = {
                        summary: this.questionnaireAnswersLang[i].respuesta,
                        details: this.questionnaireAnswersLang[i].desglose,
                        languageID: this.questionnaireAnswersLang[i].idiomaid,
                        languageName: ''
                    };

                    var j;
                    for (j = 0; j < this.languages.length; j++)
                    {
                        if (this.questionnaireAnswersLang[i].idiomaid === this.languages[j].idiomaid)
                        {
                            answer.languageName = this.languages[j].idioma;
                            break;
                        }
                    }
                    this.answerLangArray.push(answer);
                }
            }

            //console.log("questionnaireAnswersLang = ", this.questionnaireAnswersLang);

            //console.log('answerLangArray = ', this.answerLangArray);

            if (situationType === "1")//Situación Normal...
            {
                this.bDlgEditAnswer = true;
            }
            else //Situación Priorizada...
            {
                this.bDlgEditPrioritizedAnswer = true;
            }
        },

        onConfirmAnswerEdition()
        {
            //console.log('questionnaireAnswerTable = ', this.questionnaireAnswerTable);

            //Si se está en modo de edición, se guardan los parámetros de la respuesta. Si no se está
            //editando, sólo se cierra la ventana:

            if (this.bEdit)
            {
                //Se guardan los parámetros de evaluación de la respuesta:
                var i;
                for (i = 0; i < this.questionnaireAnswers.length; i ++)
                {
                    if (this.questionnaireAnswers[i].respuestaid === this.editingAnswerID)
                    {
                        //Para respuesta normal:
                        this.questionnaireAnswers[i].analisis = this.respAnalisis;
                        this.questionnaireAnswers[i].costoBeneficio = this.respCostoBeneficio;
                        this.questionnaireAnswers[i].largoPlazo = this.respLargoPlazo;
                        this.questionnaireAnswers[i].pensamientoConceptual = this.respPensamientoConceptual;
                        this.questionnaireAnswers[i].interpersonal = this.respInterpersonal;
                        this.questionnaireAnswers[i].relacionamientoEstrategico = this.respRelacionamiento;
                        this.questionnaireAnswers[i].social = this.respSocial;
                        this.questionnaireAnswers[i].autoconocimiento = this.respAutoconocimiento;
                        this.questionnaireAnswers[i].ajuste = this.respAjuste;
                        this.questionnaireAnswers[i].etica = this.respEtica;

                        //Para respuesta priorizada:
                        this.questionnaireAnswers[i].relacionamientoEstrategico0 = this.relEstrategico0;
                        this.questionnaireAnswers[i].relacionamientoEstrategico1 = this.relEstrategico1;
                        this.questionnaireAnswers[i].relacionamientoEstrategico3 = this.relEstrategico3;
                        this.questionnaireAnswers[i].relacionamientoEstrategico5 = this.relEstrategico5;
                        this.questionnaireAnswers[i].relacionamientoSocial0 = this.relSocial0;
                        this.questionnaireAnswers[i].relacionamientoSocial1 = this.relSocial1;
                        this.questionnaireAnswers[i].relacionamientoSocial3 = this.relSocial3;
                        this.questionnaireAnswers[i].relacionamientoSocial5 = this.relSocial5;

                        break;
                    }
                }

                //Arreglo con las respuestas en todos los idiomas que se mandará al servidor:
                var answersLangToEdit = [];

                //Edita el arreglo de los nombres de la respuesta en los diferentes idiomas:
                for (i = 0; i < this.answerLangArray.length; i++)
                {
                    var j;
                    for (j = 0; j < this.questionnaireAnswersLang.length; j++)
                    {
                        if (this.questionnaireAnswersLang[j].respuestaid === this.editingAnswerID &&
                            this.answerLangArray[i].languageID === this.questionnaireAnswersLang[j].idiomaid)
                        {
                            this.questionnaireAnswersLang[j].respuesta = this.answerLangArray[i].summary;
                            this.questionnaireAnswersLang[j].desglose = this.answerLangArray[i].details;

                            // const questionLangToEdit = {
                            //     respuestaid: this.questionnaireAnswersLang[j].respuestaid,
                            //     idiomaid: this.questionnaireAnswersLang[j].idiomaid,
                            //     respuesta: this.questionnaireAnswersLang[j].respuesta,
                            //     desglose: this.questionnaireAnswersLang[j].desglose
                            // };

                            //answersLangToEdit.push(questionLangToEdit);

                            //Se edita la tabla questionnaireAnswerTable:
                            var k;

                            //El arreglo questionnaireAnswerTable tiene dimensiones de
                            //núm. de situaciones (k) x núm. de respuestas por situación (l), por lo que cada situación k
                            //se recorre l veces para buscar la respuesta a editar:
                            
                            for (k = 0; k < this.questionnaireAnswerTable.length; k++)
                            {
                                var l;
                                for (l = 0; l < this.questionnaireAnswerTable[k].length; l++)
                                {
                                    if (this.questionnaireAnswerTable[k][l].answerID === this.editingAnswerID)
                                    {
                                        const idiomaid = this.answerLangArray[i].languageID;
                                        this.questionnaireAnswerTable[k][l][idiomaid] = this.answerLangArray[i].summary;

                                        break;
                                    }
                                }
                            }
                        }
                    }
                }
            }

            this.bDlgEditAnswer = false;
            this.bDlgEditPrioritizedAnswer = false;
        },
        onCancelAnswerEdition() {
            this.bDlgEditAnswer = false;
        },

        onDeleteAnswer(situationID, item)
        {
            this.editingSituationID = situationID;
            this.answerToDeleteID = item.answerID;
            this.bDlgDeletingAnswer = true;
        },

        cancelDeleteAnswer()
        {
            this.editingSituationID = 0;
            this.editingAnswerID = 0;
            this.bDlgDeletingAnswer = false;
        },

        confirmDeleteAnswer()
        {
            this.deleteAnswer(this.answerToDeleteID);

            this.editingSituationID = 0;
            this.editingAnswerID = 0;
            this.bDlgDeletingAnswer = false;

            console.log("questionnaireAnswers = ", this.questionnaireAnswers);
            console.log("questionnaireAnswersLang = ", this.questionnaireAnswersLang);

            this.$store.dispatch('createQuestionnaireInfo');

        },

        deleteAnswer(answerID)
        {
            //Borra una respuesta de una situación y todos sus textos en todos los idiomas:
            var ansLangSize = this.questionnaireAnswersLang.length;
            var i;
            for (i = 0; i < ansLangSize; i ++)
            {
                if (this.questionnaireAnswersLang[i].respuestaid === answerID)
                {
                    this.questionnaireAnswersLang.splice(i, 1);
                    i --;
                    ansLangSize --;
                }
            }

            for (i = 0; i < this.questionnaireAnswers.length; i ++)
            {
                if (this.questionnaireAnswers[i].respuestaid === answerID)
                {
                    this.questionnaireAnswers.splice(i, 1);
                    break;
                }
            }
        },


        onSave()
        {
            var bDataOK = false;

            var questionnaire = {
                id: this.questionnaireID,
                titulo: this.selectedQuestionnaireName,
                numero: this.selectedQuestionnaireNumber,
                idiomas: this.questionnaireLanguages,
                introIdiomas: this.questionnaireIntros,
                situaciones: this.questionnaireSituations,
                situacionesIdiomas: this.questionnaireSituationsLang,
                respuestas: this.questionnaireAnswers,
                respuestasIdiomas: this.questionnaireAnswersLang,
                autoevaluaciones: this.questionnaireAutoevaluations,
                autoevaluacionesIdiomas: this.questionnaireAutoevaluationsLang,
            }

            console.log("questionnaire to Save = ", questionnaire);

            //Validación de datos:

            if (questionnaire.titulo === "")
            {
                this.bInvalidData = true;
                this.errorMessage = "Asigne un nombre al caso.";
            }
            else
            if (questionnaire.numero < 1)
            {
                this.bInvalidData = true;
                this.errorMessage = "Asigne un número al caso.";
            }
            else
            if (questionnaire.idiomas.length === 0)
            {
                this.bInvalidData = true;
                this.errorMessage = "Seleccione al menos un idioma para el caso.";
            }
            else
            {
                bDataOK = true;
            }
            

            if (!this.bNew && bDataOK)
            {
                //Edición de caso...
                this.$store.dispatch('editQuestionnaire', questionnaire);
            }
            else
            if (this.bNew && bDataOK)
            {
                this.bNew = false;
                this.$store.dispatch('saveNewQuestionnaire', questionnaire);
            }

            if (bDataOK)
            {
                this.bEdit = false;
            }
        },

        onCancel()
        {
            if (this.bNew)
            {
                this.selectFirstQuestionnaire();
                this.bNew = false;
            }
            else
            {
               //Vuelve a obtener todos los casos:
               this.$store.dispatch('fetchQuestionnaires');
               this.selectQuestionnaire(this.questionnaireID);
            }
            this.bEdit = false;
        },

        onSearch() {
            if (this.searchText != '') {
                //Se convierte el texto a minúsculas para hacer la comparación:

                var searchTextLowerCase = this.searchText.toLowerCase();

                var i;
                var bFound = false;
                for (i = 0; i < this.questionnaires.length; i++)
                {
                    var strLowerCaseText = this.questionnaires[i].titulo.toLowerCase();
                    if (strLowerCaseText.indexOf(searchTextLowerCase) === 0)
                    {
                        this.selectedQuestionnaireIndex = i;
                        this.selectQuestionnaire(this.questionnaires[i].id);
                        bFound = true;
                        break;
                    }
                }
                if (!bFound)
                {
                    this.bShowNotFoundAlert = true;
                }
                this.searchText = '';
            }
        }
    },
    computed: {
        ...mapGetters([
            'questionnaires',
            'waitCursor',
            'languages',
            'questionnaireIntros',
            'questionnaireIntroTable',
            'questionnaireTablesHeader',
            'questionnaireAnswerHeader',
            'questionnaireSituationTable',
            'questionnaireAnswers'
        ]),
        selectedQuestionnaireIndex: {
            get() {
                return this.$store.getters.selectedQuestionnaireIndex;
            },
            set(selectedQuestionnaireIndex) {
                this.$store.dispatch(
                    'updateSelectedQuestionnaireIndex',
                    selectedQuestionnaireIndex
                );
            }
        },
        searchNewQuestionnaire: {
            get() {
                return this.$store.getters.searchNewQuestionnaire;
            },
            set(searchNewQuestionnaire) {
                this.$store.dispatch(
                    'updateSearchNewQuestionnaire',
                    searchNewQuestionnaire
                );
            }
        },
        newQuestionnaireID: {
            get() {
                return this.$store.getters.newQuestionnaireID;
            },
            set(newQuestionnaireID) {
                this.$store.dispatch(
                    'updateNewQuestionnaireID',
                    newQuestionnaireID
                );
            }
        },

        questionnaireLanguages: {
            get() {
                return this.$store.getters.questionnaireLanguages;
            },
            set(questionnaireLanguages) {
                this.$store.dispatch(
                    'updateQuestionnaireLanguages',
                    questionnaireLanguages
                );
            }
        },

        questionnaireSituations: {
            get() {
                return this.$store.getters.questionnaireSituations;
            },
            set(questionnaireSituations) {
                this.$store.dispatch(
                    'updateQuestionnaireSituations',
                    questionnaireSituations
                );
            }
        },
        
        questionnaireSituationsLang: {
            get() {
                return this.$store.getters.questionnaireSituationsLang;
            },
            set(questionnaireSituationsLang) {
                this.$store.dispatch(
                    'updateQuestionnaireSituationsLang',
                    questionnaireSituationsLang
                );
            }
        },

        questionnaireAutoevaluations: {
            get() {
                return this.$store.getters.questionnaireAutoevaluations;
            },
            set(questionnaireAutoevaluations) {
                this.$store.dispatch(
                    'updateQuestionnaireAutoevaluations',
                    questionnaireAutoevaluations
                );
            }
        },

         questionnaireAutoevaluationsLang: {
            get() {
                return this.$store.getters.questionnaireAutoevaluationsLang;
            },
            set(questionnaireAutoevaluationsLang) {
                this.$store.dispatch(
                    'updateQuestionnaireAutoevaluationsLang',
                    questionnaireAutoevaluationsLang
                );
            }
        },

        questionnaireAutoevaluationTable: {
            get() {
                return this.$store.getters.questionnaireAutoevaluationTable;
            },
            set(questionnaireAutoevaluationTable) {
                this.$store.dispatch(
                    'updateQuestionnaireAutoevaluationTable',
                    questionnaireAutoevaluationTable
                );
            }
        },

        questionnaireAnswers: {
            get() {
                return this.$store.getters.questionnaireAnswers;
            },
            set(questionnaireAnswers) {
                this.$store.dispatch(
                    'updateQuestionnaireAnswers',
                    questionnaireAnswers
                );
            }
        },
        questionnaireAnswersLang: {
            get() {
                return this.$store.getters.questionnaireAnswersLang;
            },
            set(questionnaireAnswersLang) {
                this.$store.dispatch(
                    'updateQuestionnaireAnswersLang',
                    questionnaireAnswersLang
                );
            }
        },
        questionnaireAnswerTable: {
            get() {
                return this.$store.getters.questionnaireAnswerTable;
            },
            set(questionnaireAnswerTable) {
                this.$store.dispatch(
                    'updateQuestionnaireAnswerTable',
                    questionnaireAnswerTable
                );
            }
        },
        questionnaireNotDeletedWarning: {
            get() {
                return this.$store.getters.questionnaireNotDeletedWarning;
            },
            set(questionnaireNotDeletedWarning) {
                this.$store.dispatch(
                    'updateQuestionnaireNotDeletedWarning',
                    questionnaireNotDeletedWarning
                );
            }
        },

        serverResponse: {
            get() {
                return this.$store.getters.serverResponse;
            },
            set(serverResponse) {
                this.$store.dispatch('updateServerResponse', serverResponse);
            }
        },

        questionnaireLoaded: {
            get() {
                return this.$store.getters.questionnaireLoaded;
            },
            set(questionnaireLoaded) {
                this.$store.dispatch('updateQuestionnaireLoaded', questionnaireLoaded);
            },
        },

        loadingQuestionnaire: {
            get() {
                return this.$store.getters.loadingQuestionnaire;
            },
            set(loadingQuestionnaire) {
                this.$store.dispatch('updateLoadingQuestionnaire', loadingQuestionnaire);
            },
        },

        listHeight() {
            var height;
            if (this.$vuetify.breakpoint.xs) {
                height = '200px';
            } else if (this.$vuetify.breakpoint.sm) {
                height = '400px';
            } else {
                height = '500px';
            }
            return height;
        },

        errorModalWidth() {
            var width = '100%';
            if (this.$vuetify.breakpoint.xs) {
                width = '80%';
            } else if (this.$vuetify.breakpoint.sm) {
                width = '60%';
            } else if (this.$vuetify.breakpoint.md) {
                width = '40%';
            } else if (this.$vuetify.breakpoint.lg) {
                width = '30%';
            } else if (this.$vuetify.breakpoint.xl) {
                width = '20%';
            }
            return width;
        },

        editModalWidth() {
            var width = '100%';
            if (this.$vuetify.breakpoint.xs) {
                width = '90%';
            } else if (this.$vuetify.breakpoint.sm) {
                width = '80%';
            } else if (this.$vuetify.breakpoint.md) {
                width = '70%';
            } else if (this.$vuetify.breakpoint.lg) {
                width = '60%';
            } else if (this.$vuetify.breakpoint.xl) {
                width = '50%';
            }
            return width;
        },

        autoEvalModalWidth() {
            var width = '100%';
            if (this.$vuetify.breakpoint.xs) {
                width = '90%';
            } else if (this.$vuetify.breakpoint.sm) {
                width = '85%';
            } else if (this.$vuetify.breakpoint.md) {
                width = '80%';
            } else if (this.$vuetify.breakpoint.lg) {
                width = '70%';
            } else if (this.$vuetify.breakpoint.xl) {
                width = '60%';
            }
            return width;
        },

        editAnswerModalWidth() {
            var width = '100%';
            if (this.$vuetify.breakpoint.xs) {
                width = '95%';
            } else if (this.$vuetify.breakpoint.sm) {
                width = '80%';
            } else if (this.$vuetify.breakpoint.md) {
                width = '75%';
            } else if (this.$vuetify.breakpoint.lg) {
                width = '70%';
            } else if (this.$vuetify.breakpoint.xl) {
                width = '60%';
            }
            return width;
        },

        editPrioritizedAnswerWidth() {
            var width = '100%';
            if (this.$vuetify.breakpoint.xs) {
                width = '90%';
            } else if (this.$vuetify.breakpoint.sm) {
                width = '70%';
            } else if (this.$vuetify.breakpoint.md) {
                width = '60%';
            } else if (this.$vuetify.breakpoint.lg) {
                width = '55%';
            } else if (this.$vuetify.breakpoint.xl) {
                width = '45%';
            }
            return width;
        }
    },
    watch: {
        questionnaireLoaded: function (value, oldValue) {
            //console.log("questionnaireLoaded changed...");
            if (this.questionnaireLoaded)
            {
                this.createLanguagesArray();
                this.questionnaireLoaded = false;
                //console.log("questionnaireSituationTable = ", this.questionnaireSituationTable);
                //console.log("questionnaireAnswerTable = ", this.questionnaireAnswerTable)
            }
        },

        searchNewQuestionnaire: function(value, oldValue) {
            //console.log('SearchNewQuestionnaire old value: ', oldValue);
            //console.log('SearchNewQuestionnaire new value: ', value);

            if (this.newQuestionnaireID !== 0) {
                this.selectQuestionnaire(this.newQuestionnaireID);
                this.searchNewQuestionnaire = false;
                this.newQuestionnaireID = 0;
            }
        },
        serverResponse: function(value, oldValue) {
            if (this.serverResponse) {
                if (this.questionnaireNotDeletedWarning) {
                    this.bQuestionnaireNotDeleted = true;
                    this.questionnaireNotDeletedWarning = false;
                } else {
                    //El cuestionario se pudo borrar.
                    //Primero se borra el cuestionario de la lista questionnaires, la cual es local:
                    var i;
                    for (i = 0; i < this.questionnaires.length; i++)
                    {
                        if (this.questionnaires[i].id === this.questionnaireID)
                        {
                            this.questionnaires.splice(i, 1);
                            break;
                        }
                    }
                    this.selectFirstQuestionnaire();
                }
            }

            this.serverResponse = false;
        }
    }
};
</script>

<style scoped>
.sub-window {
    background: rgba(224, 224, 224, 0.6);
}
.questionnaires {
    /* background: url('../assets/alex-kotliarskyi-QBpZGqEMsKg-unsplash.jpg'); */
    /*background: url('../assets/ben-rosett-WdJkXFQ4VHY-unsplash.jpg');*/
    background: url('../assets/hunters-race-MYbhN8KaaEc-unsplash.jpg');
    background-size: cover;
    width: 100%;
    height: 100%;
}

.my-list-title {
    font-size: 15px;
    font-weight: bold;
}
.my-list-subtitle {
    font-size: 13px;
    font-weight: bold;
}
.my-list-header {
    font-size: 11px;
    font-weight: bold;
    background-color: #e0e0e0;
}
.my-list-item {
    min-height: 30px !important;
}

/* ***************Modificaciones para que no se parta el texto en v-card-text y en v-card-title (al parecer es un bug de vuetify):************* */
.v-card__text,
.v-card__title {
    word-break: normal; /* maybe !important  */
}
</style>